<template>
<Flex>
  <div class="fund-screener-v2 white flex4 flexColumn">
    <b-loading is-full-page :active="viewIsLoading" />
              <Flex class="mainAxisFlexEnd">
                <div :class="`flex base1 flexBasis300Px allAroundPadding ${!showingPortfolioSideBar ? 'base1 pointer' : 'white'}`"
                  @click="showingPortfolioSideBar = true"
                >
                  <p class="whiteText heavy">
                    Portfolio Editor
                  </p>
                  <Flex class="mainAxisFlexEnd crossAxisCenter">
                    <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M0.993184 5.46891L5.24186 1.22024C5.53551 0.926584 6.01037 0.926584 6.3009 1.22024L7.00693 1.92627C7.30059 2.21993 7.30059 2.69478 7.00693 2.98532L3.99537 5.99687L7.00693 9.00843C7.30059 9.30209 7.30059 9.77694 7.00693 10.0675L6.30402 10.7798C6.01037 11.0734 5.53551 11.0734 5.24498 10.7798L0.996308 6.53108C0.699526 6.23742 0.699526 5.76257 0.993184 5.46891Z" fill="white"/>
                      <path d="M6.99318 5.46891L11.2419 1.22024C11.5355 0.926584 12.0104 0.926584 12.3009 1.22024L13.0069 1.92627C13.3006 2.21993 13.3006 2.69478 13.0069 2.98532L9.99537 5.99687L13.0069 9.00843C13.3006 9.30209 13.3006 9.77694 13.0069 10.0675L12.304 10.7798C12.0104 11.0734 11.5355 11.0734 11.245 10.7798L6.99631 6.53108C6.69953 6.23742 6.69953 5.76257 6.99318 5.46891Z" fill="white"/>
                    </svg>
                  </Flex>
                </div>
              </Flex>
              <Flex class="crossAxisCenter sideMargins4">
                <p class="fontSize1AndHalf bold rightMargin2">
                  Fund Screener
                </p>
                <div class="minWidth250Px">
                  <TypeAheadFundSearchNew
                    rounded
                    :callback="fundSelectCallback"
                  />
                </div>
                <p class="bold leftMargin2 rightMargin grayText">
                  Universe:
                </p>
                <div class="minWidth250Px">
                  <TypeaheadPortfolioSearch
                    placeholder="Select a starting universe"
                    :selected="universePortfolio"
                    :callback="selectPortfolio"
                    :size="'is-small'"
                    :lightSerializer="true"
                  />
                </div>
                <p class="heavy leftMargin2 base1Text pointer" @click="openInfoModal">
                  Help
                </p>
              </Flex>
              <Flex class="crossAxisCenter sideMargins4 bottomMargin topMargin2 flexWrap">
                <b-dropdown
                  append-to-body
                  scrollable
                  max-height="400"
                  trap-focus
                >
                  <template #trigger>
                    <div class="base1 slightCurvedBorder pointer bottomMargin" @click="openValuesPicker()">
                      <p class="whiteText heavy sideMargins topBottomHalfMargin fontSizeThreeQuarters">
                        Choose Values
                      </p>
                    </div>
                  </template>
                  <div class="width250Px sidePadding">
                    <ValuesPicker
                      v-if="valuePickersOpenState['first']"
                      :currentlyApplied="activeValues.a"
                      :callback="valuesChangeCallback"
                    />
                  </div>
                </b-dropdown>
                <b-dropdown
                  append-to-body
                  scrollable
                  max-height="400"
                  trap-focus
                  v-for="value in activeValues.a"
                  :key="value.id"
                >
                  <template #trigger>
                    <div class="base1 slightCurvedBorder pointer rightPadding bottomMargin"
                      :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)' }"
                    >
                      <p class="base1Text heavy leftMargin topBottomHalfMargin fontSizeThreeQuarters inlineBlockDisplay">
                        {{value.name}}
                      </p>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M5.47171 9.00875L1.22038 4.75742C0.92654 4.46358 0.92654 3.98843 1.22038 3.69772L1.92685 2.99125C2.22069 2.69741 2.69584 2.69741 2.98656 2.99125L6 6.00469L9.01344 2.99125C9.30728 2.69741 9.78243 2.69741 10.0731 2.99125L10.7796 3.69772C11.0735 3.99156 11.0735 4.46671 10.7796 4.75742L6.52829 9.00875C6.2407 9.30259 5.76555 9.30259 5.47171 9.00875Z" fill="#8C67EF"/>
                      </svg>
                    </div>
                  </template>
                  <div class="width300Px">
                    <Flex class="flexColumn topPadding">
                      <Flex class="bottomMarginHalf topMarginHalf fontSizeHalf flexColumn sidePadding boxShadowBottom">
                        <Flex>
                          <div class="bold">
                            {{value.name}}
                          </div>
                          <Flex class="mainAxisFlexEnd base1Text heavy fontSizeThreeQuarters pointer" @click="filters.columns[`composite_values_${value.id}`][0] = 0; filters.columns[`composite_values_${value.id}`][1] = 10; maybeGetResults()">Reset</Flex>
                        </Flex>
                        <Flex>
                          <Flex v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="i" class="width25Px height25Px centerCenter"
                            :style="{color: textColorScaleNoBackground(i)}"
                          >
                            {{i}}
                          </Flex>
                        </Flex>
                        <Flex :style="{justifyContent: 'center'}">
                          <b-slider
                            v-bind:min="0"
                            v-bind:max="10"
                            v-model="filters.columns[`composite_values_${value.id}`]"
                            v-on:change="maybeGetResults"
                            :tooltip="false"
                            :style="{width: '90%'}"
                            rounded
                          />
                        </Flex>
                      </Flex>
                      <div class="blackBorder base5 topMarginHalf">
                        <Flex class="bottomMargin2 topMargin fontSizeHalf flexColumn sidePadding" v-for="metric in value.metrics.filter(metric => metric.details)" :key="metric.details.id">
                          <Flex>
                            <div class="grayText bold">
                              {{metric.details.name}}
                            </div>
                            <Flex class="mainAxisFlexEnd base1Text heavy fontSizeThreeQuarters pointer"  @click="filters.columns[metric.metric_description][0] = 0; filters.columns[metric.metric_description][1] = 1; maybeGetResults()">Reset</Flex>
                          </Flex>
                          <Flex>
                            <Flex v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="i" class="width25Px height25Px centerCenter"
                              :style="{color: textColorScaleNoBackground(i)}"
                            >
                              {{i}}
                            </Flex>
                          </Flex>
                          <Flex :style="{justifyContent: 'center'}">
                            <b-slider
                              v-bind:min="0"
                              v-bind:max="1"
                              v-bind:step="0.1"
                              v-model="filters.columns[metric.metric_description]"
                              v-on:change="maybeGetResults"
                              :tooltip="false"
                              :style="{width: '90%', marginTop: '3px'}"
                              rounded
                            />
                          </Flex>
                        </Flex>
                      </div>
                      <Flex class="bottomPaddingHalf fontSizeHalf stickBottom white">
                        <Flex class="sidePadding">
                          <div class="redText bold pointer" @click="valuesChangeCallback(activeValues.a.filter(activeValue => activeValue.id !== value.id))">
                            Remove {{value.name}}
                          </div>
                        </Flex>
                      </Flex>
                    </Flex>
                  </div>
                </b-dropdown>
              </Flex>
              <Flex class="crossAxisCenter sideMargins4 bottomMargin">
                <div class="">
                  <Flex v-if="!this.results.error" class="grayText fontSizeHalf crossAxisCenter flexWrap">
                    <!-- <p class="bold blackText inlineBlockDisplay">{{Object.keys(filters.columns).length}}</p><div class="leftMarginHalf rightMargin">Filters:</div> -->
                    <div v-if="exchanging" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)', color: '#8C67EF', border: '1px solid #8C67EF' }">
                      <Flex>
                        <div>
                          <strong>Exchange Mode:</strong> Swapping {{ exchanging.ticker__symbol || 'fund' }}
                          <span v-if="activeValues.a.length === 0" class="leftMarginHalf grayText fontSizeHalf">
                            (showing similar category funds)
                          </span>
                        </div>
                        <div class="leftPaddingHalf pointer" @click="closeExchangeMode">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div v-if="filters.symbolSearch" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Symbol Search:</div>
                        <div class="leftMarginHalf extraBold">{{filters.symbolSearch}}</div>
                        <div class="leftPaddingHalf pointer" @click="filters.symbolSearch = null; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>

                    <div v-if="filters.nameSearch" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Name Search:</div>
                        <div class="leftMarginHalf extraBold">{{filters.nameSearch}}</div>
                        <div class="leftPaddingHalf pointer" @click="filters.nameSearch = null; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>

                    <div
                      v-if="filters.shareClass?.length"
                      class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy"
                      :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">

                      <Flex>
                        <div>Share Class:</div>
                        <div class="leftMarginHalf extraBold">{{ filters.shareClass.join('; ') }}</div>
                        <div
                          class="leftPaddingHalf pointer"
                          @click="filters.shareClass = []; maybeGetResultsWithValuesReload()">
                          <i class='fa fa-times'></i>
                        </div>
                      </Flex>
                    </div>

                    <div @click="clickElement('categoryDropdown')" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy pointer" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Style Categories:</div>
                        <template v-if="filters.fundType.length > 0">
                          <div
                            v-for="(category, idx) in filters.fundType.slice(0, 3)"
                            :key="category"
                            class="leftMarginHalf extraBold"
                          >
                            {{ category }}<span v-if="idx < Math.min(filters.fundType.length, 3) - 1">,</span>
                          </div>
                          <div v-if="filters.fundType.length > 3" class="leftMarginHalf extraBold">
                            and {{ filters.fundType.length - 3 }} more
                          </div>
                        </template>
                        <div v-if="filters.assetType.includes('2')" class="leftMarginHalf extraBold">ETF<span v-if="filters.assetType.includes('3')">,</span></div>
                        <div v-if="filters.assetType.includes('3')" class="leftMarginHalf extraBold">Mutual Fund</div>
                      </Flex>
                    </div>
                    <div v-if="universePortfolio" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Universe:</div>
                        <div class="leftMarginHalf extraBold">{{universePortfolio.name}}</div>
                        <div class="leftPaddingHalf pointer" @click="universePortfolio = null; maybeGetResultsWithValuesReload()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div v-if="filters.columns['ticker__expense_ratio'][0] !== 0 || filters.columns['ticker__expense_ratio'][1] !== 0.03" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Expense ratio</div>
                        <div class="leftMarginHalf extraBold">{{(filters.columns['ticker__expense_ratio'][0] * 100).toFixed(2)}}% to {{(filters.columns['ticker__expense_ratio'][1] * 100).toFixed(2)}}%</div>
                        <div class="leftPaddingHalf pointer" @click="filters.columns['ticker__expense_ratio'][0] = 0; filters.columns['ticker__expense_ratio'][1] = 0.03; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div v-if="filters.columns['ticker__total_value'][0] !== 0" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Assets over</div>
                        <div class="leftMarginHalf extraBold">${{(filters.columns['ticker__total_value'][0])}}{{headerConfig.minAssets}}</div>
                        <div class="leftPaddingHalf pointer" @click="filters.columns['ticker__total_value'][0] = 0; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div 
                      v-for="(filterKey) in filterColumnKeys()" 
                      :key="`financial-${filterKey}`"
                      v-if="filterKey.startsWith('financial_data.') && filters.columns[filterKey] && filters.columns[filterKey] !== 0" 
                      class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" 
                      :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>{{formatFinancialDataLabel(filterKey)}} min</div>
                        <div class="leftMarginHalf extraBold">{{filters.columns[filterKey]}}%</div>
                        <div class="leftPaddingHalf pointer" @click="filters.columns[filterKey] = 0; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div  v-if="filters.engagementLevel > 0" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <Flex @click="clickElement('engagementDropdown')" class="pointer">
                          <div>At least</div>
                          <div class="leftMarginHalf extraBold"> {{engagementLevelString}} engagement</div>
                        </Flex>
                        <div class="leftPaddingHalf pointer" @click="filters.engagementLevel = 0; maybeGetResultsWithValuesReload()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div v-if="filters.esgMandate" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div class="leftMarginHalf extraBold">With ESG Mandate</div>
                        <div class="leftPaddingHalf pointer" @click="filters.esgMandate = null; maybeGetResultsWithValuesReload()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div
                      v-if="activeValues.a.length > 0 && filters.columns['composite'] && (filters.columns['composite'][0] !== 0 || filters.columns['composite'][1] !== 10)" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>Overall Alignment</div>
                        <div class="leftMarginHalf extraBold">{{filters.columns['composite'] ? (filters.columns['composite'][0] + ' to ' + filters.columns['composite'][1]) : ''}}</div>
                        <div class="leftPaddingHalf pointer" @click="filters.columns['composite'] && (filters.columns['composite'][0] = 0, filters.columns['composite'][1] = 10, maybeGetResults())">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div 
                      v-for="(filterKey) in filterColumnKeys()" :key="filterKey"
                      v-if="activeValues.a.length > 0 && filterKey.includes('composite_') && (filters.columns[filterKey][0] !== 0 || filters.columns[filterKey][1] !== 10)" class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                      <Flex>
                        <div>{{getValueNameFromFilterKey(filterKey)}}</div>
                        <div class="leftMarginHalf extraBold">{{(filters.columns[filterKey])[0]}} to {{(filters.columns[filterKey])[1]}}</div>
                        <div class="leftPaddingHalf pointer" @click="filters.columns[filterKey][0] = 0; filters.columns[filterKey][1] = 10; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                    <div 
                      v-for="(filterKey) in filterColumnKeys()" 
                      :key="`metric-${filterKey}`"
                      v-if="activeValues.a.length > 0 && individualMetricColumns.includes(filterKey) && (filters.columns[filterKey][0] !== 0 || filters.columns[filterKey][1] !== 1) && !isNaN(filters.columns[filterKey][0]) && !isNaN(filters.columns[filterKey][1])" 
                      class="gray allAroundPaddingHalf topMargin bottomMargin rightMargin blackText fontSizeThreeQuarters slightCurvedBorder heavy" 
                      :style="{ backgroundColor: '#eeeff2', color: '#606a80' }"
                    >
                      <Flex>
                        <div>{{metrics.byId[filterKey] ? metrics.byId[filterKey].name : `Metric ${filterKey}`}}</div>
                        <div class="leftMarginHalf extraBold">
                          {{ isNaN(filters.columns[filterKey][0]) || isNaN(filters.columns[filterKey][1]) ? 'Invalid Range' : (filters.columns[filterKey][0] * 10).toFixed(1) + ' to ' + (filters.columns[filterKey][1] * 10).toFixed(1) }}
                        </div>
                        <div class="leftPaddingHalf pointer" @click="filters.columns[filterKey][0] = 0; filters.columns[filterKey][1] = 1; maybeGetResults()">
                          <svg width="8" height="8" viewBox="0 0 8 8" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M7.52969 6.47032C7.82266 6.76328 7.82266 7.23789 7.52969 7.53086C7.38438 7.67735 7.19219 7.75 7 7.75C6.80781 7.75 6.61609 7.67676 6.46984 7.53028L4 5.06172L1.53039 7.52969C1.38391 7.67735 1.19195 7.75 1 7.75C0.808047 7.75 0.616328 7.67735 0.469727 7.52969C0.176758 7.23672 0.176758 6.76211 0.469727 6.46914L2.94004 3.99883L0.469727 1.52969C0.176758 1.23672 0.176758 0.762115 0.469727 0.469147C0.762695 0.176178 1.2373 0.176178 1.53027 0.469147L4 2.94063L6.47031 0.470319C6.76328 0.17735 7.23789 0.17735 7.53086 0.470319C7.82383 0.763287 7.82383 1.2379 7.53086 1.53086L5.06055 4.00118L7.52969 6.47032Z" fill="#8C67EF"/>
                          </svg>
                        </div>
                      </Flex>
                    </div>
                  </Flex>
                </div>
              </Flex>

              <Flex class="crossAxisCenter sideMargins4 bottomMargin">
                <div class="">
                  <div v-if="!this.results.error" class="grayText is-flex is-justify-content-center is-align-items-center">
                    <span>
                      Showing
                      <span class='bold blackText'>{{ results.rows.length }}</span>
                      of
                      <span class='bold base1Text'>{{ results.total }}</span>
                      total funds
                    </span>

                    <a
                      v-if='downloadReady && downloadTaskID'
                      :href="`/api/v1/explore/funds/download/${downloadTaskID}/result`"
                      class='button is-small is-success mx-2'
                      @click='() => this.downloadReady = false'>
                      Download Ready
                    </a>

                    <b-button
                      class='mx-2'
                      size='is-small'
                      :type="this.downloadPending ? 'is-info': 'is-ghost'"
                      :loading='downloadPending'
                      @click='requestDownload'
                      v-else>
                      Download
                    </b-button>
                  </div>
                </div>
                <Flex class="mainAxisFlexEnd">
                  <div>
                    <Flex class="">
                      <div class="allAroundPadding bold leftBorderRadius pointer"
                        v-if="activeValues.a.length > 0 && !isLoadingValues"
                        :style="{ backgroundColor: !showingFinancialData ? 'black' : '#eeeff2', color: !showingFinancialData ? 'white' : '#606a80' }"
                        @click="showingFinancialData = false"
                      >
                        Values Screens
                      </div>
                      <div v-if="isLoadingValues" class="allAroundPadding bold leftBorderRadius" 
                        :style="{ backgroundColor: '#eeeff2', color: '#606a80' }">
                        <i class="fas fa-spinner fa-spin"></i> Loading Values...
                      </div>
                      <div class="allAroundPadding bold rightBorderRadius pointer"
                        :style="{ backgroundColor: showingFinancialData ? 'black' : '#eeeff2', color: showingFinancialData ? 'white' : '#606a80' }"
                        @click="showingFinancialData = true"
                      >
                        Financial Performance
                      </div>
                    </Flex>
                  </div>
                </Flex>
              </Flex>
              <div class="minHeight70vh maxSupportedWidthv2 minWidthFull xScroll sidePadding4 allAroundPadding">
                <b-table
                  ref="resultsTable"
                  v-if="!this.results.error"
                  v-bind:data="results.rows"
                  v-bind:loading="results.loading"
                  sticky-header
                  :loading-can-cancel="false"
                  :loading-is-full-page="false"
                  v-bind:total="results.total"
                  v-bind:per-page="results.perPage"
                  v-bind:current-page="results.page"
                  paginated
                  backend-pagination
                  backend-sorting
                  v-on:sort="onResultsSort"
                  v-on:page-change="onResultsPageChange"
                  default-sort-direction="desc"
                  v-bind:default-sort="['composite', 'desc']"
                  icon-pack="fas"
                  :row-class="() => ''"
                >
                  <b-table-column
                    label="Pin"
                    sticky
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <Flex class="crossAxisCenter">
                        <div class="grayText fontSizeHalf centerText" >
                          <div class=''>
                            {{ column.label }}
                          </div>
                        </div>
                      </Flex>
                    </template>
                    <template v-slot="props">
                      <svg class="pointer" width="8" height="13" viewBox="0 0 8 13" fill="none" xmlns="http://www.w3.org/2000/svg" @click="addPinned(props.row)">
                        <g clip-path="url(#clip0_934_9833)">
                          <path :fill="isFundPinned(props.row) ? '#805EE6' : '#D0D4DC'" d="M7.75 3.875C7.75 5.73828 6.23828 7.25 4.375 7.25C2.51102 7.25 1 5.73828 1 3.875C1 2.01102 2.51102 0.5 4.375 0.5C6.23828 0.5 7.75 2.01102 7.75 3.875ZM4.75 2C4.75 1.79281 4.58125 1.625 4.375 1.625C3.11172 1.625 2.125 2.63234 2.125 3.875C2.125 4.08125 2.29281 4.25 2.5 4.25C2.70625 4.25 2.875 4.08125 2.875 3.875C2.875 3.04766 3.54766 2.375 4.375 2.375C4.58125 2.375 4.75 2.20719 4.75 2ZM3.625 11.75V7.93203C3.86875 7.97656 4.11953 7.97891 4.375 7.97891C4.63047 7.97891 4.88125 7.97656 5.125 7.93203V11.75C5.125 12.1648 4.78984 12.5 4.375 12.5C3.96016 12.5 3.625 12.1648 3.625 11.75Z" />
                        </g>
                        <defs>
                          <clipPath id="clip0_934_9833">
                            <rect width="7.5" height="12" fill="white" transform="translate(0.25 0.5)"/>
                          </clipPath>
                        </defs>
                      </svg>
                    </template>
                  </b-table-column>
                  <b-table-column
                    :visible="actionsColumnVisible"
                    label="Actions"
                    sticky
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <p class="grayText fontSizeHalf centerText">{{ column.label }}</p>
                    </template>
                    <template v-slot="props">
                      <div v-if="showingPortfolioSideBar" class="slightCurvedBorder pointer bottomMargin centerText" @click="sendHoldingsToPortfolio([props.row])" :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)' }">
                        <p class="base1Text heavy sideMargins topBottomHalfMargin fontSizeHalf">
                          Add
                        </p>
                      </div>
                      <b-tooltip
                        v-if="exchanging !== null"
                        type="is-white"
                        multilined
                        size="is-xxlarge"
                        position="is-right"
                        append-to-body
                      >
                        <template v-slot:content>
                          <div class="exchange-comparison">
                            <div class="columns">
                              <div
                                class="column is-half leftText rightBlackBorder"
                              >
                                <p class="grayText">
                                  <svg width="10" height="10" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M0.75 4.625H9.44062L8.09578 5.96984C7.80281 6.26281 7.80281 6.73742 8.09578 7.03039C8.24063 7.17734 8.43281 7.25 8.625 7.25C8.81719 7.25 9.00891 7.17676 9.15516 7.03027L11.7802 4.40527C12.0731 4.1123 12.0731 3.6377 11.7802 3.34473L9.15516 0.719727C8.86219 0.426758 8.38758 0.426758 8.09461 0.719727C7.80164 1.0127 7.80164 1.4873 8.09461 1.78027L9.44062 3.125H0.75C0.335391 3.125 0 3.46039 0 3.875C0 4.28961 0.335391 4.625 0.75 4.625ZM11.25 8.375H2.56172L3.90656 7.03016C4.19953 6.73719 4.19953 6.26258 3.90656 5.96961C3.61359 5.67664 3.13898 5.67664 2.84602 5.96961L0.221016 8.59461C-0.0719531 8.88758 -0.0719531 9.36219 0.221016 9.65516L2.84602 12.2802C2.99062 12.4273 3.18281 12.5 3.375 12.5C3.56719 12.5 3.75891 12.4268 3.90516 12.2803C4.19812 11.9873 4.19812 11.5127 3.90516 11.2197L2.56172 9.875H11.25C11.6646 9.875 12 9.53961 12 9.125C12 8.71039 11.6648 8.375 11.25 8.375Z" fill="#8C67EF"/>
                                  </svg>
                                  <em class="verticalAlignMiddle">Potential Replacement</em>
                                </p>
                                <p class="bold fontSize1AndQuarter">{{ props.row.ticker__symbol }}</p>
                                <p class="fund-name grayText">{{ props.row.ticker__full_name }}</p>
                                <Flex class="halfTopMargin" v-if="props.row.ticker__asset_type == 2 || props.row.ticker__asset_type == 3 || props.row.ticker__asset_type == 'ETF' || props.row.ticker__asset_type == 'Mutual Fund'">
                                  <p class="grayText">Expense Ratio</p>
                                  <Flex class="mainAxisFlexEnd bold">
                                    {{ (props.row.ticker__expense_ratio * 100).toFixed(2) }}%
                                  </Flex>
                                </Flex>
                                <Flex class="mainAxisFlexStart crossAxisCenter topMargin" v-if="activeValues.a.length > 0 && (props.row.ticker__asset_type == 2 || props.row.ticker__asset_type == 3 || props.row.ticker__asset_type == 'ETF' || props.row.ticker__asset_type == 'Mutual Fund')">
                                  <Flex
                                    :style="{backgroundColor: colorScale(props.row.composite || 0), color: textColorScale(props.row.composite || 0)}"
                                    class="slightCurvedBorder centerCenter"
                                  >
                                    <p class="heavy">
                                      {{ props.row.composite ? props.row.composite.toFixed(0) : 'N/A' }}
                                    </p>
                                  </Flex>
                                  <p class="bold leftMargin">Overall Alignment</p>
                                </Flex>
                                <Flex class="mainAxisFlexStart crossAxisCenter halfTopMargin" v-for="value in activeValues.a" :key="value.id" v-if="props.row.ticker__asset_type == 2 || props.row.ticker__asset_type == 3 || props.row.ticker__asset_type == 'ETF' || props.row.ticker__asset_type == 'Mutual Fund'">
                                  <Flex
                                    :style="{
                                      backgroundColor: colorScale(props.row[`composite_values_${value.id}`] || 0),
                                      color: textColorScale(props.row[`composite_values_${value.id}`] || 0)
                                    }"
                                    class="slightCurvedBorder centerCenter ">
                                    <p class="heavy">
                                      {{ props.row[`composite_values_${value.id}`] ? props.row[`composite_values_${value.id}`].toFixed(0) : 'N/A' }}
                                    </p>
                                  </Flex>
                                  <p class="bold leftMargin">{{value.name}}</p>
                                </Flex>
                              </div>
                              <div
                                class="column is-half leftText"
                              >
                                <p class="grayText">
                                  <svg width="12" height="9" viewBox="0 0 12 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M12 1.07143C12 1.29075 11.9163 1.51018 11.7489 1.67732L4.89174 8.53446C4.725 8.70268 4.50536 8.78572 4.28571 8.78572C4.06607 8.78572 3.84696 8.70201 3.67982 8.5346L0.25125 5.10603C0.0838393 4.93929 0 4.71964 0 4.5C0 4.01036 0.400446 3.64286 0.857143 3.64286C1.07646 3.64286 1.29589 3.72656 1.46304 3.89397L4.28571 6.71786L10.5375 0.466073C10.7036 0.298126 10.9232 0.214287 11.1429 0.214287C11.6009 0.214287 12 0.581251 12 1.07143Z" fill="#3FA25C"/>
                                  </svg>
                                  <em class="verticalAlignMiddle">Currently in Portfolio</em>
                                </p>
                                <p class="bold fontSize1AndQuarter">{{ exchanging.ticker__symbol || 'N/A' }}</p>
                                <p class="fund-name grayText">{{ exchanging.ticker__full_name || 'N/A' }}</p>
                                <Flex class="halfTopMargin" v-if="exchanging.ticker__asset_type == 2 || exchanging.ticker__asset_type == 3">
                                  <p class="grayText">Expense Ratio</p>
                                  <Flex class="mainAxisFlexEnd bold">
                                    {{ exchanging.ticker__expense_ratio ? (exchanging.ticker__expense_ratio * 100).toFixed(2) + '%' : 'N/A' }}
                                  </Flex>
                                </Flex>
                                <Flex class="mainAxisFlexStart crossAxisCenter topMargin" v-if="exchanging.composite && activeValues.a.length > 0 && (exchanging.ticker__asset_type == 2 || exchanging.ticker__asset_type == 3)">
                                  <Flex
                                    :style="{backgroundColor: colorScale(exchanging.composite || 0), color: textColorScale(exchanging.composite || 0)}"
                                    class=" slightCurvedBorder centerCenter"
                                  >
                                    <p class="heavy">
                                      {{ exchanging.composite ? exchanging.composite.toFixed(0) : 'N/A' }}
                                    </p>
                                  </Flex>
                                  <p class="bold leftMargin">Overall Alignment</p>
                                </Flex>
                                <Flex class="mainAxisFlexStart crossAxisCenter halfTopMargin" v-for="value in activeValues.a" :key="value.id" v-if="exchanging[`composite_values_${value.id}`] && (exchanging.ticker__asset_type == 2 || exchanging.ticker__asset_type == 3)">
                                  <Flex
                                    :style="{
                                      backgroundColor: colorScale(exchanging[`composite_values_${value.id}`] || 0),
                                      color: textColorScale(exchanging[`composite_values_${value.id}`] || 0)
                                    }"
                                    class=" slightCurvedBorder centerCenter ">
                                    <p class="heavy">
                                      {{ exchanging[`composite_values_${value.id}`] ? exchanging[`composite_values_${value.id}`].toFixed(0) : 'N/A' }}
                                    </p>
                                  </Flex>
                                  <p class="bold leftMargin">{{value.name}}</p>
                                </Flex>
                              </div>
                            </div>
                          </div>
                        </template>
                        <div v-if="exchanging" class="slightCurvedBorder pointer" @click="exchangeHolding(props.row)" :style="{ backgroundColor: 'rgba(128, 94, 230, 0.2)' }">
                          <p class="base1Text heavy sideMargins topBottomHalfMargin fontSizeHalf">
                            Swap
                          </p>
                        </div>
                        <div v-else class="slightCurvedBorder" :style="{ backgroundColor: '#f5f5f5', color: '#ccc' }">
                          <p class="base1Text heavy sideMargins topBottomHalfMargin fontSizeHalf">
                            Swap
                          </p>
                        </div>
                      </b-tooltip>
                    </template>
                  </b-table-column>

                  <b-table-column
                    field="ticker__symbol"
                    narrow
                    label="Ticker, Name, and Share Class"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        max-height="400"
                        trap-focus
                        position="is-bottom-right"
                        close-on-click
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.symbolSearch ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === 'ticker__symbol' && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === 'ticker__symbol' && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <Flex class="flexColumn maxHeightFull normalFontWeight sideMargins">
                          <Flex class="flexColumn">
                            <Flex class="allAroundPadding fontSizeHalf bottomBlackBorder">
                              <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === 'ticker__symbol' && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                  @click="onResultsSort('ticker__symbol', 'asc')">
                                  <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                      :fill=" `${sort.column === 'ticker__symbol' && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                    />
                                  </svg>
                                  <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                                </Flex>
                              <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === 'ticker__symbol' && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                @click="onResultsSort('ticker__symbol', 'desc')">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                    :fill=" `${sort.column === 'ticker__symbol' && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                  />
                                </svg>
                                <p class="leftMarginHalf noWrap">Sort Descending</p>
                              </Flex>
                            </Flex>
                            <Flex :class="`allAroundMargin flexColumn `">
                              <div class="bottomMargin">
                                <b-input
                                  v-model="filters.symbolSearch"
                                  v-on:input="debouncedGetResults(true)"
                                  placeholder="Search Fund Symbols"
                                  size="is-small"
                                />
                              </div>
                              <div class="bottomMargin">
                                <b-input
                                  v-model="filters.nameSearch"
                                  v-on:input="debouncedGetResults(true)"
                                  placeholder="Search Fund Names"
                                  size="is-small"
                                />
                              </div>
                              <Flex>
                                <b-input size="is-small" class="fullWidth" placeholder="Search share classes" v-model="shareClassInput"/>
                              </Flex>
                              <Flex class="yScroll maxHeight250Px flexColumn topMargin">
                                <Flex :class="`bottomMargin ${filters.shareClasses.includes(type) ? 'bold' : ''}`" v-for="(type) in filteredShareClasses" :key="type">
                                  <b-checkbox size="is-small" v-model="filters.shareClass" :native-value="type" @input="maybeGetResultsWithValuesReload()">{{type}}</b-checkbox>
                                </Flex>
                              </Flex>
                            </Flex>
                          </Flex>
                        </Flex>
                      </b-dropdown>
                    </template>
                    <template v-slot="props" >
                      <Flex class="flexColumn mainAxisCenter topBottomPadding fullHeight">
                        <Flex>
                          <router-link :to="showingFinancialData ? { path: '/advisor/checkup/auto-portfolio', query: { fund_screener_fund: props.row.ticker__symbol } } : { path: `/advisor/fund-screener/${props.row.ticker__symbol}`, query: { metricIds: JSON.stringify(activeValues.a.reduce((acc, val) => { acc.push(...val.metrics.map(metric => metric.metric_description)); return acc; }, [])) } }"
                            target="_blank"
                            class="heavy fontSize1AndHalf blackText">
                            {{ props.row.ticker__symbol }}
                          </router-link>
                          <Flex class="mainAxisFlexEnd rightPadding crossAxisCenter heavy fontSizeHalf grayText">
                            {{props.row.ticker__share_class}}
                          </Flex>
                        </Flex>
                        <div class="grayText" :style="{minWidth: '200px'}">
                          {{props.row.ticker__full_name}}
                        </div>
                      </Flex>
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="ticker__benchmark_description"
                    label="Category and Type"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                        @active-change="onCategoryDropdownActiveChange"
                      >
                        <template #trigger>
                          <Flex id="categoryDropdown" class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.fundType.length ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === 'ticker__benchmark_description' && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === 'ticker__benchmark_description' && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <Flex class="allAroundPadding flexColumn maxHeightFull normalFontWeight">
                          <Flex class="flexColumn allAroundPaddingHalf fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer allAroundPaddingHalf ${sort.column === 'ticker__benchmark_description' && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort('ticker__benchmark_description', 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === 'ticker__benchmark_description' && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer allAroundPaddingHalf ${sort.column === 'ticker__benchmark_description' && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort('ticker__benchmark_description', 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === 'ticker__benchmark_description' && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex>
                            <b-input size="is-small" class="fullWidth" placeholder="Search categories" v-model="searchFundTypesInput"/>
                          </Flex>
                          <Flex class="flexRow bottomMargin">
                            <b-button size="is-small" @click="filters.fundType = filteredFundTypes.slice()" class="rightMarginHalf">Select All</b-button>
                            <b-button size="is-small" @click="filters.fundType = []">Deselect All</b-button>
                          </Flex>
                          <Flex class="yScroll maxHeight250Px flexColumn topMargin">
                            <Flex :class="`bottomMargin ${filters.fundType.includes(type) ? 'bold' : ''}`" v-for="(type) in filteredFundTypes" :key="type">
                              <b-checkbox size="is-small" v-model="filters.fundType" :native-value="type">{{type}}</b-checkbox>
                            </Flex>
                          </Flex>
                          <Flex class="maxHeight250Px flexColumn topMargin topBlackBorder topPadding">
                            <Flex :class="`bottomMargin ${filters.assetType.includes('2') ? 'bold' : ''}`">
                              <b-checkbox size="is-small" v-model="filters.assetType" native-value="2">ETF</b-checkbox>
                            </Flex>
                            <Flex :class="`bottomMargin ${filters.assetType.includes('3') ? 'bold' : ''}`">
                              <b-checkbox size="is-small" v-model="filters.assetType" native-value="3">Mutual Fund</b-checkbox>
                            </Flex>
                          </Flex>
                        </Flex>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                        <p class="" :style="{minWidth: '150px'}">
                          {{ props.row.ticker__benchmark_description }}
                        </p>
                        <p class="fontSizeHalf grayText">
                            {{ props.row.ticker__asset_type == 2 ? 'ETF' : (props.row.ticker__asset_type == 3 ? 'Mutual Fund' : props.row.ticker__asset_type) }}
                        </p>
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="engagement_level"
                    label="Engagement"
                    v-bind:visible="!showingFinancialData"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                        close-on-click
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer" id="engagementDropdown">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.engagementLevel ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                          </Flex>
                        </template>
                        <Flex class="allAroundPadding flexColumn maxHeightFull normalFontWeight">
                          <Flex class="flexColumn topMargin">
                            <Flex :class="`bottomMargin ${filters.engagementLevel === 0 ? 'bold' : ''}`">
                              <b-radio size="is-small" v-model="filters.engagementLevel" @input="maybeGetResultsWithValuesReload()" :native-value="0">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path opacity="0.1" d="M6 11.5L0 8.5L6 5.5L12 8.5L6 11.5Z" fill="#353A46"/>
                                  <path opacity="0.1" d="M6 8.5L1 6L6 3.5L11 6L6 8.5Z" fill="#353A46"/>
                                  <path d="M6 5.5L2 3.5L6 1.5L10 3.5L6 5.5Z" fill="#C0ACF6"/>
                                </svg>
                                Minimal
                              </b-radio>
                            </Flex>
                            <Flex :class="`bottomMargin ${filters.engagementLevel === 1 ? 'bold' : ''}`">
                              <b-radio size="is-small" v-model="filters.engagementLevel" @input="maybeGetResultsWithValuesReload()" :native-value="1">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path opacity="0.1" d="M6 11.5L0 8.5L6 5.5L12 8.5L6 11.5Z" fill="#353A46"/>
                                  <path d="M6 8.5L1 6L6 3.5L11 6L6 8.5Z" fill="#8C67EF"/>
                                  <path d="M6 5.5L2 3.5L6 1.5L10 3.5L6 5.5Z" fill="#C0ACF6"/>
                                </svg>
                                Base
                              </b-radio>
                            </Flex>
                            <Flex :class="`bottomMargin ${filters.engagementLevel === 2 ? 'bold' : ''}`">
                              <b-radio size="is-small" v-model="filters.engagementLevel" @input="maybeGetResultsWithValuesReload()" :native-value="2">
                                <svg width="12" height="11" viewBox="0 0 12 11" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M6 11L0 8L6 5L12 8L6 11Z" fill="#331094"/>
                                  <path d="M6 8L1 5.5L6 3L11 5.5L6 8Z" fill="#8C67EF"/>
                                  <path d="M6 5L2 3L6 1L10 3L6 5Z" fill="#C0ACF6"/>
                                </svg>
                                Deep
                                </b-radio>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn topMargin topBlackBorder topPadding">
                            <Flex :class="`bottomMargin `">
                              <b-radio size="is-small" v-model="filters.esgMandate" @input="maybeGetResultsWithValuesReload()" :native-value="true">
                                <p class="fontSizeHalf">
                                  <i class="fas fa-check-circle greenText"></i>
                                  ESG
                                </p>
                              </b-radio>
                            </Flex>
                            <Flex :class="`bottomMargin`">
                              <!-- <b-checkbox size="is-small" v-model="filters.columns['ticker__esg_mandate']" native-value="3">Mutual Fund</b-checkbox> -->
                              <b-radio size="is-small" v-model="filters.esgMandate" @input="maybeGetResultsWithValuesReload()" :native-value="false">
                                <p class="fontSizeHalf grayText lineThrough">
                                  <i class="fa fa-times-circle"></i>
                                  ESG
                                </p>
                              </b-radio>
                            </Flex>
                          </Flex>
                        </Flex>
                      </b-dropdown>
                      <span class="pointer grayText fontSizeHalf" @click="openInfoModal">
                        <i class="fa fa-question-circle"></i>
                      </span>
                    </template>
                    <template v-slot="props">
                      <p class="fontSizeHalf">

                        {{ props.row.ticker__engagement_level == 2 ? 'Deep Engagement' : (props.row.ticker__engagement_level == 1 ? 'Base Engagement' : 'Min Engagement') }}
                      </p>
                      <p class="fontSizeHalf">
                        <i v-if="props.row.ticker__esg_mandate" class="fas fa-check-circle greenText"></i>
                        <i v-else class="fa fa-times-circle redText"></i>
                        ESG
                      </p>
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="ticker__expense_ratio"
                    label="Expense"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                        close-on-click
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns['ticker__expense_ratio'][0] || filters.columns['ticker__expense_ratio'][1] < 0.03 ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === 'ticker__expense_ratio' && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === 'ticker__expense_ratio' && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <Flex class="flexColumn maxHeightFull normalFontWeight sideMargins">
                          <Flex class="flexColumn">
                            <Flex class="allAroundPadding fontSizeHalf bottomBlackBorder">
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === 'ticker__expense_ratio' && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                @click="onResultsSort('ticker__expense_ratio', 'asc')">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    :fill=" `${sort.column === 'ticker__expense_ratio' && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                  />
                                </svg>
                                <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                              </Flex>
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === 'ticker__expense_ratio' && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                @click="onResultsSort('ticker__expense_ratio', 'desc')">
                                <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                    :fill=" `${sort.column === 'ticker__expense_ratio' && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                  />
                                </svg>
                                <p class="leftMarginHalf noWrap">Sort Descending</p>
                              </Flex>
                            </Flex>
                            <Flex :class="`topMargin flexColumn `">
                              <Flex class="fontSizeHalf sideMargins">
                                <p class="grayText">Filter by <strong>expense ratio</strong></p>
                                <Flex class="mainAxisFlexEnd bold base1Text pointer" @click="filters.columns['ticker__expense_ratio'] = [0, 0.03]; maybeGetResults()">Reset</Flex>
                              </Flex>
                              <Flex class="sideMargins">
                                <b-slider
                                  rounded
                                  class="is-primary"
                                  size="is-small"
                                  v-bind:step="0.0005"
                                  v-bind:min="0"
                                  v-bind:max="0.03"
                                  v-model="filters.columns['ticker__expense_ratio']"
                                  v-on:change="maybeGetResults"
                                  v-bind:custom-formatter="pctFormat"
                                />
                              </Flex>
                              <Flex class="fontSizeHalf topMarginHalf sideMarginHalf">
                                <Flex class="leftMarginHalf">0%</Flex>
                                <Flex class="mainAxisFlexEnd">3%</Flex>
                              </Flex>
                            </Flex>
                          </Flex>
                        </Flex>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      {{ (props.row.ticker__expense_ratio * 100).toFixed(2) }}%
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="ticker__total_value"
                    label="Assets"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns['ticker__total_value'][0] ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === 'ticker__total_value' && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === 'ticker__total_value' && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <Flex class="allAroundPadding flexColumn maxHeightFull normalFontWeight">
                          <Flex class="flexColumn allAroundPaddingHalf fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer allAroundPaddingHalf ${sort.column === 'ticker__total_value' && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort('ticker__total_value', 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === 'ticker__total_value' && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer allAroundPaddingHalf ${sort.column === 'ticker__total_value' && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort('ticker__total_value', 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === 'ticker__total_value' && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn topMargin topBlackBorder topPadding crossAxisCenter">
                            <Flex class="crossAxisCenter topMarginHalf">
                              <p class="rightMargin grayText fontSizeHalf">$</p>
                              <b-input
                                size='is-small' placeholder="Minimum"
                                v-model="filters.columns['ticker__total_value'][0]"
                                @input="maybeGetResults()"
                              />
                              <p :class="`leftMargin fontSizeHalf pointer ${headerConfig.minAssets === 'm' ? 'base1Text' : 'grayText'}`" @click="headerConfig.minAssets = 'm'; maybeGetResults()">m</p>
                              <p :class="`leftMargin fontSizeHalf pointer ${headerConfig.minAssets === 'b' ? 'base1Text' : 'grayText'}`" @click="headerConfig.minAssets = 'b'; maybeGetResults()">b</p>

                            </Flex>
                          </Flex>
                        </Flex>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                      style="height: 2em;"
                        v-bind:label="'As of period ending on ' + props.row.ticker__holdings_as_of_date"
                      >
                        {{ bigDollarFormat(Math.round(props.row.ticker__total_value)) }}
                      </b-tooltip>
                    </template>
                  </b-table-column>
                  <b-table-column
                    field="composite"
                    label="Overall Alignment"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :visible="!showingFinancialData && activeValues.a.length > 0"
                  >
                    <template v-slot:header="{ column }">
                          <b-dropdown
                            append-to-body
                            scrollable
                            max-height="400"
                            trap-focus
                          >
                            <template #trigger>
                              <Flex class="crossAxisCenter pointer">
                                <div class="grayText fontSizeHalf centerText" >
                                  <div class='rightMarginHalf'>
                                    <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns['composite'][0] || filters.columns['composite'][1] < 10 ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="1" y="1" width="10" height="1" rx="0.5" />
                                      <rect x="3" y="4" width="6" height="1" rx="0.5" />
                                      <rect x="4" y="7" width="4" height="1" rx="0.5" />
                                    </svg>

                                    {{ column.label }}
                                  </div>
                                </div>
                                <div v-if="sort.column === 'composite' && sort.dir === 'desc'">
                                  <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                      fill="#8C67EF"
                                    />
                                  </svg>
                                </div>
                                <div v-if="sort.column === 'composite' && sort.dir === 'asc'">
                                    <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                        fill="#8C67EF"
                                      />
                                    </svg>
                                </div>
                              </Flex>
                            </template>
                            <div class="width300Px">
                              <Flex class="flexColumn topPadding bottomPadding">
                                <Flex class="bottomMarginHalf topMarginHalf flexColumn fontSizeHalf sidePadding">
                                  <Flex class="bottomMargin">
                                    <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === 'composite' && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                      @click="onResultsSort('composite', 'asc')">
                                      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                          :fill=" `${sort.column === 'composite' && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                        />
                                      </svg>
                                      <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                                    </Flex>
                                    <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === 'composite' && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                      @click="onResultsSort('composite', 'desc')">
                                      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                          :fill=" `${sort.column === 'composite' && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                        />
                                      </svg>
                                      <p class="leftMarginHalf noWrap">Sort Descending</p>
                                    </Flex>
                                  </Flex>
                                  <Flex>
                                    <div class="bold">
                                      Overall Alignment
                                    </div>
                                  </Flex>
                                  <Flex>
                                    <Flex v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="i" class="width25Px height25Px centerCenter"
                                      :style="{color: textColorScaleNoBackground(i)}"
                                    >
                                      {{i}}
                                    </Flex>
                                  </Flex>
                                  <Flex :style="{justifyContent: 'center'}">
                                    <b-slider
                                      v-bind:min="0"
                                      v-bind:max="10"
                                      v-model="filters.columns['composite']"
                                      v-on:change="maybeGetResults"
                                      :tooltip="false"
                                      :style="{width: '90%'}"
                                      rounded
                                    />
                                  </Flex>
                                </Flex>
                              </Flex>
                            </div>
                          </b-dropdown>
                          <span class="pointer grayText fontSizeHalf" @click="openInfoModal">
                            <i class="fa fa-question-circle"></i>
                          </span>
                    </template>
                    <template v-slot="props">
                      <div
                        :style="{backgroundColor: colorScale(props.row.composite || 0), color: textColorScale(props.row.composite || 0)}"
                        class="flex1 autoMargin slightCurvedBorder centerCenter"
                      >
                        <p class="heavy">
                          {{ props.row.composite ? props.row.composite.toFixed(0) : 'N/A' }}
                        </p>
                      </div>
                    </template>
                  </b-table-column>

                  <!--
                    This if statement is a workaround for a Vue reactivity related bug where the last column
                    of the b-table component won't be removed when the underlying array changes.
                  -->
                  <template v-if="!results.loading">
                    <b-table-column
                      v-for="(values, index) in activeValues.a"
                      v-bind:visible="columnShouldBeVisible(values) && !showingFinancialData"
                      v-bind:key="`${index}-${values.id}`"
                      v-bind:field="`composite_values_${values.id}`"
                      v-bind:label="labelForColumn(`composite_values_${values.id}`, values)"
                      :td-attrs="() => ({style: {verticalAlign: 'middle' }})"
                    >
                      <template v-slot:header="{ column }">
                          <b-dropdown
                            append-to-body
                            scrollable
                            max-height="400"
                            trap-focus
                            position="is-bottom-left"
                          >
                            <template #trigger>
                              <Flex class="crossAxisCenter pointer centerText">
                                <div class='rightMarginHalf'>
                                  <div class="grayText fontSizeHalf " >
                                    <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns[`composite_values_${values.id}`][0] || filters.columns[`composite_values_${values.id}`][1] < 10 ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                                      <rect x="1" y="1" width="10" height="1" rx="0.5" />
                                      <rect x="3" y="4" width="6" height="1" rx="0.5" />
                                      <rect x="4" y="7" width="4" height="1" rx="0.5" />
                                    </svg>
                                    {{ column.label }}
                                  </div>
                                </div>
                                <div v-if="sort.column === `composite_values_${values.id}` && sort.dir === 'desc'">
                                  <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                      fill="#8C67EF"
                                    />
                                  </svg>
                                </div>
                                <div v-if="sort.column === `composite_values_${values.id}` && sort.dir === 'asc'">
                                    <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                      <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                        fill="#8C67EF"
                                      />
                                    </svg>
                                </div>
                              </Flex>
                            </template>
                            <div class="width300Px">
                              <Flex class="flexColumn topPadding">
                                <Flex class="bottomMarginHalf topMarginHalf fontSizeHalf flexColumn sidePadding boxShadowBottom">
                                  <Flex class="bottomMargin">
                                    <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `composite_values_${values.id}` && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                      @click="onResultsSort(`composite_values_${values.id}`, 'asc')">
                                      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                          :fill=" `${sort.column === `composite_values_${values.id}` && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                        />
                                      </svg>
                                      <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                                    </Flex>
                                    <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `composite_values_${values.id}` && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                                      @click="onResultsSort(`composite_values_${values.id}`, 'desc')">
                                      <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                          :fill=" `${sort.column === `composite_values_${values.id}` && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                        />
                                      </svg>
                                      <p class="leftMarginHalf noWrap">Sort Descending</p>
                                    </Flex>
                                  </Flex>
                                  <Flex>
                                    <div class="bold">
                                      {{values.name}}
                                    </div>
                                    <Flex class="mainAxisFlexEnd base1Text heavy fontSizeThreeQuarters pointer" @click="filters.columns[`composite_values_${values.id}`][0] = 0; filters.columns[`composite_values_${values.id}`][1] = 10; maybeGetResults()">Reset</Flex>
                                  </Flex>
                                  <Flex>
                                    <Flex v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="i" class="width25Px height25Px centerCenter"
                                      :style="{color: textColorScaleNoBackground(i)}"
                                    >
                                      {{i}}
                                    </Flex>
                                  </Flex>
                                  <Flex :style="{justifyContent: 'center'}">
                                    <b-slider
                                      v-bind:min="0"
                                      v-bind:max="10"
                                      v-model="filters.columns[`composite_values_${values.id}`]"
                                      v-on:change="maybeGetResults"
                                      :tooltip="false"
                                      :style="{width: '90%'}"
                                      rounded
                                    />
                                  </Flex>
                                </Flex>
                                <div class="blackBorder base5 topMarginHalf">
                                  <Flex class="bottomMargin2 topMargin fontSizeHalf flexColumn sidePadding  " v-for="metric in values.metrics.filter(metric => metric.details)" :key="metric.details.id">
                                    <Flex>
                                      <div class="grayText bold">
                                        {{metric.details.name}}
                                      </div>
                                      <Flex class="mainAxisFlexEnd base1Text heavy fontSizeThreeQuarters pointer"  @click="filters.columns[metric.metric_description][0] = 0; filters.columns[metric.metric_description][1] = 1; maybeGetResults()">Reset</Flex>
                                    </Flex>
                                    <Flex>
                                      <Flex v-for="i in [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" :key="i" class="width25Px height25Px centerCenter"
                                        :style="{color: textColorScaleNoBackground(i)}"
                                      >
                                        {{i}}
                                      </Flex>
                                    </Flex>
                                    <Flex :style="{justifyContent: 'center'}">
                                      <b-slider
                                        v-bind:min="0"
                                        v-bind:max="1"
                                        v-bind:step="0.1"
                                        v-model="filters.columns[metric.metric_description]"
                                        v-on:change="maybeGetResults"
                                        :tooltip="false"
                                        :style="{width: '90%', marginTop: '3px'}"
                                        rounded
                                      />
                                    </Flex>
                                  </Flex>
                                </div>
                                <Flex class="bottomPaddingHalf fontSizeHalf stickBottom white">
                                  <Flex class="sidePadding">
                                    <div class="redText bold pointer" @click="valuesChangeCallback(activeValues.a.filter(activeValue => activeValue.id !== values.id))">
                                      Remove {{values.name}}
                                    </div>
                                  </Flex>
                                </Flex>
                              </Flex>
                            </div>
                          </b-dropdown>
                      </template>
                      <template v-slot="props">
                        <div :style="{backgroundColor: colorScale(props.row[`composite_values_${values.id}`] || 0), color: textColorScale(props.row[`composite_values_${values.id}`] || 0)}" class="flex flex1 autoMargin  slightCurvedBorder centerCenter">
                          <p class="heavy">
                            {{ props.row[`composite_values_${values.id}`] ? props.row[`composite_values_${values.id}`].toFixed() : 'N/A' }}
                          </p>
                        </div>
                      </template>
                    </b-table-column>
                  </template>
                  <b-table-column
                    :visible="showingFinancialData"
                    :field="`financial_data.Load Adjusted Return ${headerConfig.returns[0]} Month-End`"
                    :label="`Returns`"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        scrollable
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                        @active-change="onReturnsDropdownActiveChange"
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="headerConfig.returns[0] === 'YTD' && headerConfig.returns.length === 1 ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <!-- need below for if any of the returns are being sorted -->
                            <div v-if="sort.column === `financial_data.Load Adjusted Return ${headerConfig.returns[0]} Month-End` && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === `financial_data.Load Adjusted Return ${headerConfig.returns[0]} Month-End` && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <Flex class="flexColumn allAroundPadding">
                          <Flex class=" halfTopMargin">
                            <b-checkbox class="" size="is-small" v-model="headerConfig.returns" native-value="YTD">
                              YTD
                            </b-checkbox>
                            <Flex v-if="headerConfig.returns.includes('YTD')" class="crossAxisCenter">
                            <Flex class="mainAxisFlexEnd rightMargin">
                              <svg @click="onResultsSort('financial_data.Load Adjusted Return YTD Month-End', 'desc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="rightMarginHalf pointer">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill="sort.column === `financial_data.Load Adjusted Return YTD Month-End` && sort.dir === 'desc' ? '#8C67EF' : '#D0D4DC'"
                                />
                              </svg>
                              <svg @click="onResultsSort('financial_data.Load Adjusted Return YTD Month-End', 'asc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill="sort.column === `financial_data.Load Adjusted Return YTD Month-End` && sort.dir === 'asc' ? '#8C67EF' : '#D0D4DC'"
                                />
                              </svg>
                            </Flex>
                            <b-input
                              v-model="filters.columns[`financial_data.Load Adjusted Return YTD Month-End`]"
                              :size="'is-small'"
                                placeholder="Minimum"
                              type="number"
                              class="maxWidth80Px"
                            />
                            </Flex>
                          </Flex>
                          <Flex class=" halfTopMargin">
                            <b-checkbox class="" size="is-small" v-model="headerConfig.returns" native-value="1Y">
                              1Y
                            </b-checkbox>
                            <Flex v-if="headerConfig.returns.includes('1Y')" class="crossAxisCenter">
                              <Flex class="mainAxisFlexEnd rightMargin">
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 1Y Month-End', 'desc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="rightMarginHalf pointer">
                                  <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 1Y Month-End` && sort.dir === 'desc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 1Y Month-End', 'asc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 1Y Month-End` && sort.dir === 'asc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                              </Flex>
                              <b-input
                                v-model="filters.columns[`financial_data.Load Adjusted Return 1Y Month-End`]"
                                :size="'is-small'"
                                placeholder="Minimum"
                                type="number"
                                class="maxWidth80Px"
                              />
                            </Flex>
                          </Flex>
                          <Flex class=" halfTopMargin">
                            <b-checkbox class="" size="is-small" v-model="headerConfig.returns" native-value="3Y">
                              3Y
                            </b-checkbox>
                            <Flex v-if="headerConfig.returns.includes('3Y')" class="crossAxisCenter">
                              <Flex class="mainAxisFlexEnd rightMargin">
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 3Y Month-End', 'desc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="rightMarginHalf pointer">
                                  <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 3Y Month-End` && sort.dir === 'desc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 3Y Month-End', 'asc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 3Y Month-End` && sort.dir === 'asc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                              </Flex>
                              <b-input
                                v-model="filters.columns[`financial_data.Load Adjusted Return 3Y Month-End`]"
                                :size="'is-small'"
                                placeholder="Minimum"
                                type="number"
                                class="maxWidth80Px"
                              />
                            </Flex>
                          </Flex>
                          <Flex class=" halfTopMargin">
                            <b-checkbox class="" size="is-small" v-model="headerConfig.returns" native-value="5Y">
                              5Y
                            </b-checkbox>
                            <Flex v-if="headerConfig.returns.includes('5Y')" class="crossAxisCenter">
                              <Flex class="mainAxisFlexEnd rightMargin">
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 5Y Month-End', 'desc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="rightMarginHalf pointer">
                                  <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 5Y Month-End` && sort.dir === 'desc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 5Y Month-End', 'asc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 5Y Month-End` && sort.dir === 'asc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                              </Flex>
                              <b-input
                                v-model="filters.columns[`financial_data.Load Adjusted Return 5Y Month-End`]"
                                :size="'is-small'"
                                placeholder="Minimum"
                                type="number"
                                class="maxWidth80Px"
                              />
                            </Flex>
                          </Flex>
                          <Flex class=" halfTopMargin">
                            <b-checkbox class="" size="is-small" v-model="headerConfig.returns" native-value="10Y">
                              10Y
                            </b-checkbox>
                            <Flex v-if="headerConfig.returns.includes('10Y')" class="crossAxisCenter">
                              <Flex class="mainAxisFlexEnd rightMargin">
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 10Y Month-End', 'desc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="rightMarginHalf pointer">
                                  <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 10Y Month-End` && sort.dir === 'desc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                                <svg @click="onResultsSort('financial_data.Load Adjusted Return 10Y Month-End', 'asc')" width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg" class="pointer">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    :fill="sort.column === `financial_data.Load Adjusted Return 10Y Month-End` && sort.dir === 'asc' ? '#8C67EF' : '#D0D4DC'"
                                  />
                                </svg>
                              </Flex>
                              <b-input
                                v-model="filters.columns[`financial_data.Load Adjusted Return 10Y Month-End`]"
                                :size="'is-small'"
                                placeholder="Minimum"
                                type="number"
                                class="maxWidth80Px"
                              />
                            </Flex>
                          </Flex>
                        </Flex>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                        v-bind:label="'As of period ending on ' + (new Date((new Date).setDate(0)).toLocaleDateString('en-US', {timeZone: 'UTC'}))"
                      >
                        <Flex class="flexColumn">
                          <!-- sort these returns by year -->
                          <Flex v-for="returnTimeFrame in sortedReturns" :key="returnTimeFrame" :class="`crossAxisCenter ${headerConfig.returns.length > 1 ? 'bottomMargin' : ''}`">
                            <Flex class="grayText fontSizeHalf rightMargin">
                              {{returnTimeFrame}}
                            </Flex>
                            <Flex :class="`mainAxisFlexEnd ${headerConfig.returns.length > 1 ? 'fontSizeThreeQuarters' : ''}`">
                              {{ returnNumberToShow(props.row[`financial_data.Load Adjusted Return ${returnTimeFrame} Month-End`]) }}%
                            </Flex>
                          </Flex>
                        </Flex>
                      </b-tooltip>
                    </template>
                  </b-table-column>

                  <b-table-column
                    :visible="showingFinancialData"
                    :field="`financial_data.Alpha ${headerConfig.alpha} Total Mo-End`"
                    :label="`Alpha ${headerConfig.alpha}`"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        scrollable
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                      >
                        <template #trigger>
                          <!-- <p class="grayText fontSizeHalf centerText">{{ column.label }}</p> -->
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns[`financial_data.Alpha ${headerConfig.alpha} Total Mo-End`] ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === `financial_data.Alpha ${headerConfig.alpha} Total Mo-End` && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === `financial_data.Alpha ${headerConfig.alpha} Total Mo-End` && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>

                        </template>
                        <div class="">
                          <Flex class="topMargin fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Alpha ${headerConfig.alpha} Total Mo-End` && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Alpha ${headerConfig.alpha} Total Mo-End`, 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === `financial_data.Alpha ${headerConfig.alpha} Total Mo-End` && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Alpha ${headerConfig.alpha} Total Mo-End` && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Alpha ${headerConfig.alpha} Total Mo-End`, 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === `financial_data.Alpha ${headerConfig.alpha} Total Mo-End` && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn allAroundPadding">
                          <b-tooltip label="Filter on a minimum alpha">
                            <b-input
                              v-model="filters.columns[`financial_data.Alpha ${headerConfig.alpha} Total Mo-End`]"
                              @input="maybeGetResults"
                              @click.native.stop=""
                              :size="'is-small'"
                              placeholder="Minimum"
                              type="number"
                            />
                          </b-tooltip>
                            <b-radio v-for="timeframe in ['1Y', '3Y', '5Y', '10Y', '15Y']" class="topMargin"
                              size="is-small"
                              :key="timeframe" v-model="headerConfig.alpha" :native-value="timeframe" @input="headerConfig.alpha = timeframe">{{timeframe}}</b-radio>
                          </Flex>
                        </div>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                        v-bind:label="'As of period ending on ' + (new Date((new Date).setDate(0)).toLocaleDateString('en-US', {timeZone: 'UTC'}))"
                      >
                        {{ returnNumberToShow(props.row[`financial_data.Alpha ${headerConfig.alpha} Total Mo-End`]) }}%
                      </b-tooltip>
                    </template>
                  </b-table-column>
                  <b-table-column
                    :visible="showingFinancialData"
                    :field="`financial_data.Beta ${headerConfig.beta} Total Mo-End`"
                    :label="`Beta ${headerConfig.beta}`"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        scrollable
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns[`financial_data.Beta ${headerConfig.beta} Total Mo-End`] ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === `financial_data.Beta ${headerConfig.beta} Total Mo-End` && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === `financial_data.Beta ${headerConfig.beta} Total Mo-End` && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <div class="">
                          <Flex class="topMargin fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Beta ${headerConfig.beta} Total Mo-End` && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Beta ${headerConfig.beta} Total Mo-End`, 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === `financial_data.Beta ${headerConfig.beta} Total Mo-End` && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Beta ${headerConfig.beta} Total Mo-End` && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Beta ${headerConfig.beta} Total Mo-End`, 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === `financial_data.Beta ${headerConfig.beta} Total Mo-End` && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn allAroundPadding">
                          <b-tooltip label="Filter on a minimum Beta">
                            <b-input
                              v-model="filters.columns[`financial_data.Beta ${headerConfig.beta} Total Mo-End`]"
                              @input="maybeGetResults"
                              @click.native.stop=""
                              :size="'is-small'"
                              placeholder="Minimum"
                              type="number"
                            />
                          </b-tooltip>
                            <b-radio v-for="timeframe in ['1Y', '3Y', '5Y', '10Y', '15Y']" class="topMargin"
                              size="is-small"
                              :key="timeframe" v-model="headerConfig.beta" :native-value="timeframe" @input="headerConfig.beta = timeframe">{{timeframe}}</b-radio>
                          </Flex>
                        </div>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                        v-bind:label="'As of period ending on ' + (new Date((new Date).setDate(0)).toLocaleDateString('en-US', {timeZone: 'UTC'}))"
                      >
                        {{ returnNumberToShow(props.row[`financial_data.Beta ${headerConfig.beta} Total Mo-End`]) }}%
                      </b-tooltip>
                    </template>
                  </b-table-column>
                  <b-table-column
                    :visible="showingFinancialData"
                    :field="`financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End`"
                    :label="`Sharpe ${headerConfig.sharpe}`"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        scrollable
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns[`financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End`] ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === `financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End` && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === `financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End` && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <div class="">
                          <Flex class="topMargin fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End` && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End`, 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === `financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End` && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End` && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End`, 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === `financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End` && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn allAroundPadding">
                          <b-tooltip label="Filter on a minimum Sharpe Ratio">
                            <b-input
                              v-model="filters.columns[`financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End`]"
                              @input="maybeGetResults"
                              @click.native.stop=""
                              :size="'is-small'"
                              placeholder="Minimum"
                              type="number"
                            />
                          </b-tooltip>
                            <b-radio v-for="timeframe in ['1Y', '3Y', '5Y', '10Y', '15Y']" class="topMargin"
                              size="is-small"
                              :key="timeframe" v-model="headerConfig.sharpe" :native-value="timeframe" @input="headerConfig.sharpe = timeframe">{{timeframe}}</b-radio>
                          </Flex>
                        </div>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                        v-bind:label="'As of period ending on ' + (new Date((new Date).setDate(0)).toLocaleDateString('en-US', {timeZone: 'UTC'}))"
                      >
                        {{ returnNumberToShow(props.row[`financial_data.Sharpe Ratio ${headerConfig.sharpe} Total Mo-End`]) }}%
                      </b-tooltip>
                    </template>
                  </b-table-column>
                  <b-table-column
                    :visible="showingFinancialData"
                    :field="`financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency`"
                    :label="`Std Dev ${headerConfig.std}`"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        scrollable
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns[`financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency`] ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === `financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency` && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === `financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency` && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <div class="">
                          <Flex class="topMargin fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency` && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency`, 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === `financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency` && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency` && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency`, 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === `financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency` && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn allAroundPadding">
                          <b-tooltip label="Filter on a minimum Standard Deviation">
                            <b-input
                              v-model="filters.columns[`financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency`]"
                              @input="maybeGetResults"
                              @click.native.stop=""
                              :size="'is-small'"
                              placeholder="Minimum"
                              type="number"
                            />
                          </b-tooltip>
                            <b-radio v-for="timeframe in ['1Y', '3Y', '5Y', '10Y', '15Y']" class="topMargin"
                              size="is-small"
                              :key="timeframe" v-model="headerConfig.std" :native-value="timeframe" @input="headerConfig.std = timeframe">{{timeframe}}</b-radio>
                          </Flex>
                        </div>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                        v-bind:label="'As of period ending on ' + (new Date((new Date).setDate(0)).toLocaleDateString('en-US', {timeZone: 'UTC'}))"
                      >
                        {{ returnNumberToShow(props.row[`financial_data.Standard Deviation ${headerConfig.std} Total Mo-End - Base Currency`]) }}%
                      </b-tooltip>
                    </template>
                  </b-table-column>
                  <b-table-column
                    :visible="showingFinancialData"
                    :field="`financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End`"
                    :label="`R-Squared ${headerConfig.rSquared}`"
                    :td-attrs="() => ({style: {verticalAlign: 'middle'}})"
                    :th-attrs="() => ({style: {verticalAlign: 'middle'}})"
                  >
                    <template v-slot:header="{ column }">
                      <b-dropdown
                        scrollable
                        max-height="400"
                        trap-focus
                        position="is-bottom-left"
                      >
                        <template #trigger>
                          <Flex class="crossAxisCenter pointer">
                            <svg width="12" height="9" viewBox="0 0 12 9" :stroke="filters.columns[`financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End`] ? '#8C67EF': '#D0D4DC'" xmlns="http://www.w3.org/2000/svg">
                              <rect x="1" y="1" width="10" height="1" rx="0.5" />
                              <rect x="3" y="4" width="6" height="1" rx="0.5" />
                              <rect x="4" y="7" width="4" height="1" rx="0.5" />
                            </svg>
                            <div class='leftMarginHalf rightMarginHalf'>
                              <p class="grayText fontSizeHalf " >
                                {{ column.label }}
                              </p>
                            </div>
                            <div v-if="sort.column === `financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End` && sort.dir === 'desc'">
                              <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  fill="#8C67EF"
                                />
                              </svg>
                            </div>
                            <div v-if="sort.column === `financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End` && sort.dir === 'asc'">
                                <svg width="10" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                  <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                    fill="#8C67EF"
                                  />
                                </svg>
                            </div>
                          </Flex>
                        </template>
                        <div class="">
                          <Flex class="topMargin fontSizeHalf">
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End` && sort.dir === 'asc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End`, 'asc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M1.07737 7.37297L0.499308 6.79491C0.254544 6.55014 0.254544 6.15436 0.499308 5.9122L5.55864 0.85026C5.8034 0.605496 6.19919 0.605496 6.44135 0.85026L11.5007 5.90959C11.7454 6.15436 11.7454 6.55015 11.5007 6.79231L10.9226 7.37037C10.6753 7.61773 10.2717 7.61253 10.0295 7.35995L7.04285 4.22488V11.7084C7.04285 12.0547 6.76423 12.3334 6.41792 12.3334H5.58468C5.23836 12.3334 4.95975 12.0547 4.95975 11.7084V4.22488L1.9705 7.36255C1.72834 7.61773 1.32474 7.62294 1.07737 7.37297Z"
                                  :fill=" `${sort.column === `financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End` && sort.dir === 'asc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap rightMargin">Sort Ascending</p>
                            </Flex>
                            <Flex :class="`crossAxisCenter pointer sideMargins allAroundPaddingHalf ${sort.column === `financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End` && sort.dir === 'desc' ? 'base1 curvedBorder whiteText' : 'grayText2'}`"
                              @click="onResultsSort(`financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End`, 'desc')">
                              <svg width="12" height="13" viewBox="0 0 12 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M10.9239 5.62704L11.502 6.2051C11.7467 6.44986 11.7467 6.84565 11.502 7.08781L6.44265 12.1497C6.19788 12.3945 5.80209 12.3945 5.55993 12.1497L0.497996 7.08781C0.253232 6.84305 0.253232 6.44726 0.497996 6.2051L1.07606 5.62704C1.32342 5.37967 1.72703 5.38488 1.96919 5.63746L4.95844 8.77513V1.29159C4.95844 0.945271 5.23705 0.666656 5.58337 0.666656H6.41661C6.76292 0.666656 7.04154 0.945271 7.04154 1.29159V8.77513L10.0308 5.63746C10.2729 5.38228 10.6765 5.37707 10.9239 5.62704Z"
                                  :fill=" `${sort.column === `financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End` && sort.dir === 'desc' ? '#FFF' : '#969EB0'}`"
                                />
                              </svg>
                              <p class="leftMarginHalf noWrap">Sort Descending</p>
                            </Flex>
                          </Flex>
                          <Flex class="flexColumn allAroundPadding">
                          <b-tooltip label="Filter on a minimum R-Squared">
                            <b-input
                              v-model="filters.columns[`financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End`]"
                              @input="maybeGetResults"
                              @click.native.stop=""
                              :size="'is-small'"
                              placeholder="Minimum"
                              type="number"
                            />
                          </b-tooltip>
                            <b-radio v-for="timeframe in ['1Y', '3Y', '5Y', '10Y', '15Y']" class="topMargin"
                              size="is-small"
                              :key="timeframe" v-model="headerConfig.rSquared" :native-value="timeframe" @input="headerConfig.rSquared = timeframe">{{timeframe}}</b-radio>
                          </Flex>
                        </div>
                      </b-dropdown>
                    </template>
                    <template v-slot="props">
                      <b-tooltip
                        v-bind:label="'As of period ending on ' + (new Date((new Date).setDate(0)).toLocaleDateString('en-US', {timeZone: 'UTC'}))"
                      >
                        {{ returnNumberToShow(props.row[`financial_data.R-Squared ${headerConfig.rSquared} Total Mo-End`]) }}%
                      </b-tooltip>
                    </template>
                  </b-table-column>
                  <b-table-column v-if="debugMode" field="ticker__pct_coverage_at_least_one_metric" label="Coverage">
                    <template v-slot="props">
                      {{ props.row.ticker__pct_coverage_at_least_one_metric }}
                    </template>
                  </b-table-column>
                  <b-table-column v-if="debugMode" field="ticker__pct_coverage_at_least_one_nonzero_metric" label="Nonzero Coverage">
                    <template v-slot="props">
                      {{ props.row.ticker__pct_coverage_at_least_one_nonzero_metric }}
                    </template>
                  </b-table-column>
                  <!-- </template> -->
                </b-table>
            </div>
        </div>
    <div v-show="showingPortfolioSideBar" class="white flex1 flexColumn leftBlackBorder maxWidth300Px">
      <div class="">
        <div class="flex black flexBasis300Px height44Px width300Px minWidth300Px allAroundPadding pointer"
          @click="showingPortfolioSideBar = false"
          v-if="showingPortfolioSideBar"
        >
          <p class="whiteText heavy">
            Portfolio Editor
          </p>
          <Flex class="mainAxisFlexEnd crossAxisCenter">
            <svg width="16" height="12" viewBox="0 0 16 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M13.0072 6.53109L8.75851 10.7798C8.46485 11.0734 7.99 11.0734 7.69947 10.7798L6.99344 10.0737C6.69978 9.78007 6.69978 9.30522 6.99344 9.01468L10.005 6.00313L6.99344 2.99157C6.69978 2.69791 6.69978 2.22306 6.99344 1.93252L7.69634 1.22024C7.99 0.926585 8.46485 0.926585 8.75539 1.22024L13.0041 5.46892C13.3008 5.76258 13.3008 6.23743 13.0072 6.53109Z" fill="#8C67EF"/>
              <path d="M7.00694 6.53109L2.75827 10.7798C2.46461 11.0734 1.98976 11.0734 1.69922 10.7798L0.993193 10.0737C0.699535 9.78007 0.699535 9.30522 0.993193 9.01468L4.00475 6.00313L0.993193 2.99157C0.699535 2.69791 0.699535 2.22306 0.993193 1.93252L1.6961 1.22024C1.98976 0.926585 2.46461 0.926585 2.75514 1.22024L7.00381 5.46892C7.3006 5.76258 7.3006 6.23743 7.00694 6.53109Z" fill="#8C67EF"/>
            </svg>
          </Flex>
        </div>
        <div class="allAroundPadding2 maxHeight90vh minHeight70vh yScroll">
          <WorkingPortfolioNew :values="activeValues" funds />
        </div>

      </div>
    </div>
</Flex>
</template>

<script>
import chroma from 'chroma-js';
import _ from 'lodash';
import papa from 'papaparse';
import Vue from 'vue';

import Advisor from '@frontend/dash3/js/shared/Advisor.js';

import TypeaheadPortfolioSearch from '@frontend/dash3/js/components/portfolios/TypeaheadPortfolioSearch.vue';
import TypeAheadFundSearchNew from '@frontend/components/TypeAheadFundSearchNew.vue';
import InfoModal from '@frontend/dash3/js/components/modals/InfoModal.vue';
import ValuesPicker from '@frontend/dash3/js/components/ValuesPicker.vue';
import ValuesPickerNew from '@frontend/components/ValuesPickerNew.vue';
import ValuesPickerModal from '@frontend/components/ValuesPickerModal.vue';
import ValueSetFineTuner from '@frontend/components/ValueSetFineTuner.vue';
import ValueTag from '@frontend/dash3/js/components/ValueTag.vue';

import FundDetailView from '@frontend/dash3/js/views/FundDetailView.vue';
import DownloadWidget from '@frontend/dash3/js/components/fundscreener/DownloadWidget.vue';
import WorkingPortfolioNew from '@frontend/dash3/js/components/fundscreener/WorkingPortfolioNew.vue';
import Flex from '@frontend/components/Flex.vue';
import eventBus from '@frontend/shared/EventBus.js';
import { bigDollarFormat } from '@frontend/shared/Text.js';
import telemetry from '@frontend/api/Telemetry.js';
import { reset } from 'mixpanel-browser';

const SHARE_CLASSES = [
  'Class Inv',
  'Class No Load',
  'Class T',
  'Class N',
  'ETF',
  'Class A',
  'Class Retirement',
  'Class C',
  'Class B',
  'Investor Class',
  'Class M',
  'Class Other',
  null, // Note: keeping the null value
  'Class Inst',
  'Class Adv',
  'Class S',
  'Class D'
];

export default {
  data() {
    return {
      allFunds: [], // All basic fund data
      valuesMetrics: {}, // Store values metrics separately
      individualMetricColumns: [],
      selectedValues: [], // Track selected values
      isLoadingValues: false,
      isDataLoaded: false,
      shareClassInput: '',
      viewIsLoading: false,
      debounceTimer: null,
      searchFundTypesInput: '',
      headerConfig: {
        alpha: '1Y',
        beta: '1Y',
        sharpe: '1Y',
        std: '1Y',
        rSquared: '1Y',
        returns: ['1Y'],
        minAssets: 'm',
        maxAssets: 'm',
      },
      categorySnapshot: {
        fundType: [],
        assetType: [],
      },
      returnsSnapshot: {
        returns: [],
        returnFilters: {}
      },
      valuePickersOpenState: {
        first: false,
        second: false,
      },
      showingFinancialData: true,
      debugMode: false,
      activeValues: {
        a: [],
        byId: {},
      },
      universePortfolio: null,
      // Track filters that affect values loading (category, type, universe)
      lastValuesFilters: {
        fundType: [],
        assetType: [],
        universePortfolioId: null,
      },
      workingPortfolios: [{
        holdings: [],
        name: 'Untitled Portfolio',
      }],
      portfolios: [],

      selectedMetrics: {},
      metrics: { a: [], byId: {} },
      advisor: {},
      fundTypes: [],
      fundClasses: [],
      filters: {
        fundType: ['Large Blend', 'Large Value', 'Large Growth'],
        shareClass: [],
        fundClass: null,
        assetType: ['2', '3'],
        symbolSearch: null,
        nameSearch: null,
        engagementLevel: 0,
        columns: {
          ticker__expense_ratio: [0, 0.03],
          ticker__total_value: [0, 2000000],
          composite: [0, 10],
        },
      },
      prevFilters: '',
      sort: {
        column: 'composite',
        dir: 'desc',
      },
      results: {
        rows: [],
        pinned: [],
        loading: false,
        error: false,
        total: 0,
        page: 1,
        prevPage: null,
        perPage: 25,
      },
      currentReturnTimeFrame: 'Load Adjusted Return YTD Month-End',
      detailFund: null,
      resultsDebounce: null,

      tooltipActive: true,
      tooltipAlways: false,

      showingPortfolioSideBar: false,
      exchanging: null,
      skipValuesPicker: false,
      downloadPending: false,
      downloadStart: null,
      downloadTaskID: null,
      downloadStatusInterval: null,
      downloadMessageShown: false,
      downloadReady: false,
    };
  },
  components: {
    DownloadWidget,
    FundDetailView,
    TypeaheadPortfolioSearch,
    ValuesPicker,
    ValueTag,
    WorkingPortfolioNew,
    TypeAheadFundSearchNew,
    Flex,
    ValuesPickerNew,
    ValuesPickerModal,
    ValueSetFineTuner,
  },
  methods: {
    async loadValuesMetrics(values) {
      if (!values.length) return;

      this.isLoadingValues = true;
      console.time('Load Values Metrics');
      try {
        const payload = {
          values: values,
          fund_types: this.filters.fundType,
          asset_type: this.filters.assetType,
          share_classes: this.filters.shareClass || [],
          symbol_search: this.filters.symbolSearch || '',
          name_search: this.filters.nameSearch || '',
          esg_mandate: this.filters.esgMandate || false,
          engagement_level: this.filters.engagementLevel || 0
        };
        
        // Add expense ratio filters if they exist
        if (this.filters.columns['ticker__expense_ratio']) {
          const [min, max] = this.filters.columns['ticker__expense_ratio'];
          if (min !== 0) payload.min_expense_ratio = min;
          if (max !== 0.03) payload.max_expense_ratio = max;
        }
        
        // Add total value filters if they exist
        if (this.filters.columns['ticker__total_value']) {
          const [min] = this.filters.columns['ticker__total_value'];
          if (min !== 0) payload.min_assets = min;
        }

        const response = await fetch('/api/v1/explore/funds/values-metrics/', {
          method: 'POST',
          body: JSON.stringify(payload),
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
        });

        const data = await response.json();
        // Values metrics loaded successfully
        
        // Log optimization stats if available
        if (data.calculation_stats) {
          console.log('Values calculation optimization:', {
            'Eligible tickers': data.calculation_stats.eligible_tickers_count,
            'Filters applied': data.calculation_stats.filters_applied,
            'Cache key hash': data.calculation_stats.cache_key_hash
          });
        }

        // Store values metrics by ticker ID
        this.valuesMetrics = {};
        data.metrics.forEach(metric => {
          this.valuesMetrics[metric.ticker__id] = metric;
        });
        this.individualMetricColumns = data.individual_metric_columns || [];
        console.log(`Loaded values for ${data.metrics.length} funds`);
        
        // Clean up any invalid filter columns that might have NaN values
        for (const col in this.filters.columns) {
          if (Array.isArray(this.filters.columns[col])) {
            const [min, max] = this.filters.columns[col];
            if (isNaN(min) || isNaN(max)) {
              console.log(`Removing invalid filter column ${col} with NaN values`);
              this.$delete(this.filters.columns, col);
            }
          }
        }
        
        // Debug: Log first few values entries to check data structure
        const sampleTickerIds = Object.keys(this.valuesMetrics).slice(0, 3);
        console.log('Sample values data structure:', sampleTickerIds.map(id => ({
          ticker_id: id,
          data: this.valuesMetrics[id]
        })));
        // Values metrics stored successfully
        // Individual metric columns and values metrics loaded
      } catch (error) {
        console.error('Error loading values metrics:', error);
      } finally {
        this.isLoadingValues = false;
        console.timeEnd('Load Values Metrics');
        
        // Update tracked values filters after successful load
        this.lastValuesFilters = {
          fundType: [...this.filters.fundType],
          assetType: [...this.filters.assetType],
          universePortfolioId: this.universePortfolio?.id || null,
        };
      }
    },
    async onValuesSelected(selectedValues) {
      // Values selected, updating filters
      this.selectedValues = selectedValues;

      if (selectedValues.length === 0) {
        // Clear values data
        this.valuesMetrics = {};
      } else {
        // Load values for ALL funds
        await this.loadValuesMetrics(selectedValues);
      }

      // Re-apply filters with new values data
      this.applyFiltersAndPagination();
    },
    async loadAllFundsData() {
      console.time('Load All Funds Data');
      this.viewIsLoading = true;

      // Show loading message with progress if possible
      this.loadingMessage = "Loading fund database (4,000+ funds)...";

      try {
        const response = await fetch('/api/v1/explore/funds/all/', {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken': this.$root.$data.csrfToken,
          },
        });

        // Process the data in chunks to avoid blocking the UI
        const data = await response.json();
        // All funds data loaded successfully

        // Store all data
        this.allFunds = data.funds;
        this.isDataLoaded = true;

        // Apply initial view
        this.applyFiltersAndPagination();
      } catch (error) {
        // Error loading funds data
        this.loadingMessage = "Error loading data. Please refresh the page.";
      } finally {
        this.viewIsLoading = false;
        console.timeEnd('Load All Funds Data');
      }
    },
    formatFinancialDataLabel(filterKey) {
      // Remove 'financial_data.' prefix and clean up the label
      const label = filterKey.replace('financial_data.', '');
      // Handle common patterns
      if (label.includes('Alpha')) {
        return label.replace(' Total Mo-End', '');
      }
      if (label.includes('Beta')) {
        return label.replace(' Total Mo-End', '');
      }
      if (label.includes('Sharpe Ratio')) {
        return label.replace(' Total Mo-End', '');
      }
      if (label.includes('Load Adjusted Return')) {
        return label.replace(' Month-End', '');
      }
      if (label.includes('Standard Deviation')) {
        return label.replace(' Total Mo-End - Base Currency', '');
      }
      if (label.includes('R-Squared')) {
        return label.replace(' Total Mo-End', '');
      }
      
      // Default: just return the cleaned label
      return label;
    },
    getValueNameFromFilterKey(filterKey) {
      const valueId = parseInt(filterKey.split('_')[filterKey.split('_').length - 1]);
      return this.activeValues.byId[valueId]?.name || 'Unknown Value';
    },
    filterColumnKeys() {
      return Object.keys(this.filters.columns);
    },
    applySorting(data) {
      if (!this.sort.column || !data.length) return data;

      const sortColumn = this.sort.column;
      const isAscending = this.sort.dir === 'asc';

      return data.sort((a, b) => {
        let aVal = a[sortColumn];
        let bVal = b[sortColumn];

        // If sorting by values columns and data not merged, get from valuesMetrics
        if (aVal == null && this.valuesMetrics[a.ticker__id]) {
          aVal = this.valuesMetrics[a.ticker__id][sortColumn];
        }
        if (bVal == null && this.valuesMetrics[b.ticker__id]) {
          bVal = this.valuesMetrics[b.ticker__id][sortColumn];
        }

        // Handle null/undefined values
        if (aVal == null && bVal == null) return 0;
        if (aVal == null) return isAscending ? -1 : 1;
        if (bVal == null) return isAscending ? 1 : -1;

        // Handle numeric values
        if (typeof aVal === 'number' && typeof bVal === 'number') {
          return isAscending ? aVal - bVal : bVal - aVal;
        }

        // Handle string values
        if (typeof aVal === 'string' && typeof bVal === 'string') {
          const comparison = aVal.localeCompare(bVal);
          return isAscending ? comparison : -comparison;
        }

        // Convert to strings for comparison if types don't match
        aVal = String(aVal).toLowerCase();
        bVal = String(bVal).toLowerCase();
        const comparison = aVal.localeCompare(bVal);
        return isAscending ? comparison : -comparison;
      });
    },
    applyFiltersAndPagination() {
      console.time('Frontend Filtering');

      // If a universe portfolio is selected, fall back to API calls since we need server-side filtering
      if (this.universePortfolio) {
        console.log('Universe portfolio selected - falling back to API call for filtering');
        this._getResults();
        return;
      }

      // Separate pinned funds - they should always be shown regardless of filters
      const pinnedFundIds = new Set(this.results.pinned.map(fund => fund.ticker__id));
      const unpinnedFunds = this.allFunds.filter(fund => !pinnedFundIds.has(fund.ticker__id));

      // Start with unpinned funds only for filtering
      let filtered = unpinnedFunds;

      // Starting with filtered funds

      // Symbol search filter
      if (this.filters.symbolSearch) {
        const searchTerm = this.filters.symbolSearch.toLowerCase();
        filtered = filtered.filter(fund => 
          fund.ticker__symbol && fund.ticker__symbol.toLowerCase().includes(searchTerm)
        );
        console.log('After symbol search:', filtered.length);
      }

      // Name search filter
      if (this.filters.nameSearch) {
        const searchTerm = this.filters.nameSearch.toLowerCase();
        filtered = filtered.filter(fund => 
          fund.ticker__full_name && fund.ticker__full_name.toLowerCase().includes(searchTerm)
        );
        console.log('After name search:', filtered.length);
      }

      // Fund type filter - use Set for faster lookup
      if (this.filters.fundType.length) {
        const fundTypeSet = new Set(this.filters.fundType);
        filtered = filtered.filter(fund => 
          fundTypeSet.has(fund.ticker__benchmark_description)
        );
        console.log('After fund type filter:', filtered.length, 'Looking for:', this.filters.fundType);
      }

      // Asset type filter - use Set for faster lookup
      if (this.filters.assetType.length) {
        // Map numeric codes to display names
        const assetTypeMap = {
          '2': 'ETF',
          '3': 'Mutual Fund',
        };

        const targetAssetTypes = new Set(
          this.filters.assetType.map(code => assetTypeMap[code]).filter(Boolean)
        );

        filtered = filtered.filter(fund => 
          targetAssetTypes.has(fund.ticker__asset_type)
        );
        console.log('After asset type filter:', filtered.length, 'Looking for:', Array.from(targetAssetTypes));
      }

      // Share class filter - use Set for faster lookup
      if (this.filters.shareClass && this.filters.shareClass.length) {
        const shareClassSet = new Set(this.filters.shareClass);
        filtered = filtered.filter(fund => 
          shareClassSet.has(fund.ticker__share_class)
        );
        console.log('After share class filter:', filtered.length);
      }

      // Engagement level filter
      if (this.filters.engagementLevel > 0) {
        filtered = filtered.filter(fund => 
          fund.ticker__engagement_level >= this.filters.engagementLevel
        );
        console.log('After engagement level filter:', filtered.length);
      }

      // ESG mandate filter
      if (this.filters.esgMandate !== null && this.filters.esgMandate !== undefined) {
        filtered = filtered.filter(fund => 
          fund.ticker__esg_mandate === this.filters.esgMandate
        );
        console.log('After ESG mandate filter:', filtered.length);
      }

      // Expense ratio filter
      const [minExpense, maxExpense] = this.filters.columns['ticker__expense_ratio'] || [0, 0.03];
      const beforeExpenseCount = filtered.length;
      filtered = filtered.filter(fund => 
        fund.ticker__expense_ratio >= minExpense && 
        fund.ticker__expense_ratio <= maxExpense
      );
      console.log('After expense ratio filter:', filtered.length, 'Range:', minExpense, '-', maxExpense, 'Filtered out:', beforeExpenseCount - filtered.length);

      // Total value (assets) filter
      const [minAssets, maxAssets] = this.filters.columns['ticker__total_value'] || [0, Number.MAX_SAFE_INTEGER];
      const minAssetsValue = minAssets * (this.headerConfig.minAssets === 'm' ? 1000000 : 1000000000);
      const maxAssetsValue = maxAssets * (this.headerConfig.maxAssets === 'm' ? 1000000 : 1000000000);
      const beforeAssetsCount = filtered.length;
      filtered = filtered.filter(fund => 
        fund.ticker__total_value >= minAssetsValue && 
        fund.ticker__total_value <= maxAssetsValue
      );
      console.log('After assets filter:', filtered.length, 'Min assets:', minAssetsValue, 'Filtered out:', beforeAssetsCount - filtered.length);

      // Values filters - only apply if we have values data and filters are active
      if (Object.keys(this.valuesMetrics).length > 0) {
        // Composite filter
        const [minComp, maxComp] = this.filters.columns.composite;
        if (minComp !== 0 || maxComp !== 10) {
          filtered = filtered.filter(fund => {
            const valuesData = this.valuesMetrics[fund.ticker__id];
            // if the fund has no composite field, just keep it (means there's no values data)
            if (!valuesData || valuesData.composite == null) return true;
            // otherwise only keep it if it's in range
            return valuesData.composite >= minComp && valuesData.composite <= maxComp;
          });
        }
        console.log('After composite filter:', filtered.length, 'Range:', minComp, '-', maxComp);
        
        // Specific values filters
        Object.entries(this.filters.columns).filter(([key, val]) =>
          Array.isArray(val) &&
          key !== 'composite' &&
          key !== 'ticker__expense_ratio' &&
          key !== 'ticker__total_value' &&
          key.startsWith('composite_values_') // Only composite values here
        ).forEach(([filterKey, [min, max]]) => {
          const defaultMax = 10; // composite_values always use 10 as default max
          console.log(`Processing composite values filter: ${filterKey}, min: ${min}, max: ${max}`);
          if (min !== 0 || max !== defaultMax) {
            filtered = filtered.filter(fund => {
              const valuesData = this.valuesMetrics[fund.ticker__id];
              return valuesData && 
                     valuesData[filterKey] != null &&
                     valuesData[filterKey] >= min &&
                     valuesData[filterKey] <= max;
            });
          }
        });
        console.log('After composite values filters:', filtered.length);

        // Individual metric filters (the raw metric IDs like '2', '87', '99')
        const individualFilters = Object.entries(this.filters.columns).filter(([key, val]) =>
          Array.isArray(val) &&
          this.individualMetricColumns.includes(key) // Only individual metrics here
        );
        individualFilters.forEach(([filterKey, [min, max]]) => {
          const defaultMax = 1; // Individual metrics use 1 as default max
          
          // Check if any funds actually have this metric
          const fundsWithMetric = filtered.filter(fund => {
            const valuesData = this.valuesMetrics[fund.ticker__id];
            return valuesData && valuesData[filterKey] != null;
          }).length;
          
          // Skip if no funds have this metric data
          if (fundsWithMetric === 0) {
            console.log(`Skipping individual metric filter ${filterKey} - no fund data available`);
            // Also clean up this filter to prevent future issues
            this.$delete(this.filters.columns, filterKey);
            return;
          }
          
          if (min !== 0 || max !== defaultMax) {
            const beforeCount = filtered.length;
            filtered = filtered.filter(fund => {
              const valuesData = this.valuesMetrics[fund.ticker__id];
              return valuesData &&
                     valuesData[filterKey] != null &&
                     valuesData[filterKey] >= min &&
                     valuesData[filterKey] <= max;
            });
            console.log(`Individual metric filter ${filterKey} [${min}, ${max}] reduced funds from ${beforeCount} to ${filtered.length}`);
          }
        });
        console.log('After individual values filters:', filtered.length);
      }

      // Financial data filters now
      Object.keys(this.filters.columns).forEach(filterKey => {
        console.log('Processing filter key:', filterKey);
        if (filterKey.startsWith('financial_data.')) {
          const minValue = this.filters.columns[filterKey];

          // Handle both single value and array formats
          let actualMinValue;
          if (Array.isArray(minValue)) {
            actualMinValue = minValue[0]; // Take the first element if it's an array
          } else {
            actualMinValue = minValue; // Use the value directly if it's not an array
          }

          // Only filter if we have a meaningful minimum value
          if (actualMinValue !== null && actualMinValue !== undefined && actualMinValue !== 0) {
            const beforeCount = filtered.length;

            filtered = filtered.filter(fund => {
              // Get the financial data value for this fund
              const fundValue = fund[filterKey];

              // Skip funds without this financial data
              if (fundValue === null || fundValue === undefined) {
                return false;
              }

              // Apply the minimum filter
              return fundValue >= actualMinValue;
            });

            console.log(`After ${filterKey} filter (min: ${actualMinValue}):`, filtered.length, 'Filtered out:', beforeCount - filtered.length);
          }
        }
      });

      // Skip values filters for now to isolate the issue
      console.log('Final filtered count:', filtered.length);

      // Apply sorting
      if (this.sort.column) {
        filtered = this.applySorting(filtered);
      }

      // Add pinned funds back to the results - they should always be visible
      if (this.results.pinned.length > 0) {
        // Create updated pinned funds with latest values data if available
        const updatedPinnedFunds = this.results.pinned.map(pinnedFund => {
          const valuesData = this.valuesMetrics[pinnedFund.ticker__id] || {};
          
          // Ensure composite and composite_values fields exist for pinned funds too
          if (this.activeValues.a.length > 0) {
            if (!('composite' in valuesData)) {
              valuesData.composite = null;
            }
            this.activeValues.a.forEach(valueSet => {
              const columnKey = `composite_values_${valueSet.id}`;
              if (!(columnKey in valuesData)) {
                valuesData[columnKey] = null;
              }
            });
          }
          
          return { ...pinnedFund, ...valuesData };
        });
        
        // Add pinned funds at the beginning of results
        filtered = [...updatedPinnedFunds, ...filtered];
      }

      // Apply pagination
      this.results.total = filtered.length;
      const offset = (this.results.page - 1) * this.results.perPage;
      const paginatedResults = filtered.slice(offset, offset + this.results.perPage);
      
      // Merge values data only for the displayed results (performance optimization)
      this.results.rows = paginatedResults.map(fund => {
        // Check if this is a pinned fund (already has values data merged)
        const isPinnedFund = this.results.pinned.some(pinned => pinned.ticker__id === fund.ticker__id);
        
        if (isPinnedFund) {
          // Pinned funds already have values data merged, return as-is
          return fund;
        }
        
        // For non-pinned funds, merge values data
        const valuesData = this.valuesMetrics[fund.ticker__id] || {};
        
        // Debug: Log sample merging for first few funds
        if (paginatedResults.indexOf(fund) < 3 && this.activeValues.a.length > 0) {
          console.log(`Merging values for ${fund.ticker__symbol} (ID: ${fund.ticker__id}):`, {
            hasValuesData: fund.ticker__id in this.valuesMetrics,
            valuesDataKeys: Object.keys(valuesData),
            valuesData: valuesData
          });
        }
        
        // If we have active values, ensure composite and composite_values fields exist
        if (this.activeValues.a.length > 0) {
          // Ensure overall composite score exists
          if (!('composite' in valuesData)) {
            valuesData.composite = null;
          }
          
          // Ensure composite_values scores exist for each active value set
          this.activeValues.a.forEach(valueSet => {
            const columnKey = `composite_values_${valueSet.id}`;
            if (!(columnKey in valuesData)) {
              valuesData[columnKey] = null;
            }
          });
        }
        
        return { ...fund, ...valuesData };
      });

      console.timeEnd('Frontend Filtering');
      console.log(`Filtered to ${this.results.total} funds, showing ${this.results.rows.length}`);
      
      // Clear loading state
      this.results.loading = false;
    },
    onCategoryDropdownActiveChange(active) {
      if (active) {
        this.categorySnapshot = {
          fundType: [...this.filters.fundType],
          assetType: [...this.filters.assetType],
        };
      } else {
        // Dropdown is closing - check for changes
        const ftChanged = JSON.stringify(this.filters.fundType) !== JSON.stringify(this.categorySnapshot.fundType);
        const atChanged = JSON.stringify(this.filters.assetType) !== JSON.stringify(this.categorySnapshot.assetType);
        if (ftChanged || atChanged) {
          this.maybeGetResultsWithValuesReload();
        }
      }
    },
    onReturnsDropdownActiveChange(active) {
      if (active) {
        // Dropdown is opening - capture the snapshot
        this.returnsSnapshot = {
          returns: [...this.headerConfig.returns],
          returnFilters: { ...this.getReturnFilters() }
        };
      } else {
        // Dropdown is closing - check for changes
        const returnsChanged = JSON.stringify(this.headerConfig.returns) !== JSON.stringify(this.returnsSnapshot.returns);
        const filtersChanged = JSON.stringify(this.getReturnFilters()) !== JSON.stringify(this.returnsSnapshot.returnFilters);
        if (returnsChanged || filtersChanged) {
          this.maybeGetResults();
        }
      }
    },
    getReturnFilters() {
      // Extract all return-related filters from this.filters.columns
      const returnFilters = {};
      Object.keys(this.filters.columns).forEach(key => {
        if (key.includes('Load Adjusted Return') && key.includes('Month-End')) {
          returnFilters[key] = this.filters.columns[key];
        }
      });
      return returnFilters;
    },
    async loadImpactFactors() {
      const res = await fetch('/api/v1/impact_factors/');
      const data = await res.json();

      data.metrics.forEach((item) => {
        this.metrics.a.push(item);
        this.metrics.byId[item.id] = item;
      });
    },
    async loadFundTypes() {
      const res = await fetch('/api/v1/taxonomy/fund_types/');
      const data = await res.json();

      data.fund_types.forEach((item) => {
        this.fundTypes.push(item);
      });
    },
    async loadPortfolios() {
      const res = await fetch('/api/v1/portfolios/?light_serializer=true');
      const data = await res.json();

      this.portfolios.push(...data.portfolios);
    },
    clickElement(elementId) {
      document.getElementById(elementId).click();
    },
    fundSelectCallback(fund) {
      // Extract only the metric IDs needed for highlighting
      const metricIds = this.activeValues.a.reduce((acc, val) => {
      acc.push(...val.metrics.map(metric => metric.metric_description));
      return acc;
      }, []);
      
      const query = {};
      if (metricIds.length > 0) {
      query.metricIds = JSON.stringify(metricIds);
      }

      this.$router.push({ 
      name: 'detail', 
      params: { symbol: `${fund.ticker.symbol}` },
      query
      });
    },
    bigDollarFormat: bigDollarFormat,
    colorScale(number) {
      if (!number && number != 0) {
        return '#fff';
      }
      number = number.toFixed(0);
      const colors = ['#49040F', '#DE2131', '#C83A1E', '#DE7021', '#F4DEB8', '#F5EABA', '#E4E9C6', '#C4E37D', '#A7D572', '#8AC468', '#3FA25C'];
      return colors[number];
    },
    textColorScale(number) {
      if (!number && number != 0) {
        return '#fff';
      }
      number = number.toFixed(0);
      const colors = ['#DD3C57', '#FFFFFF', '#FBD7D0', '#F6DBD5', '#AC8035', '#9B8C4B', '#868E57', '#FFFFFF', '#FFFFFF', '#FFFFFF', '#FFFFFF'];
      return colors[number];
    },
    textColorScaleNoBackground(number) {
      if (!number && number != 0) {
        return '#000';
      }
      number = number.toFixed(0);
      const colors = ['#DD3C57', '#DE2131', '#C83A1E', '#DE7021', '#AC8035', '#9B8C4B', '#868E57', '#9DCD2D', '#8EC94A', '#6EB446', '#3FA25C'];
      return colors[number];
    },
    openInfoModal: function() {
      this.$buefy.modal.open({
        parent: this,
        component: InfoModal,
        hasModalCard: true,
        trapFocus: true,
        props: {},
      });
    },
    openValuesPicker: function(currentlyApplied) {
      this.tooltipActive = false;
      this.$buefy.modal.open({
        parent: this,
        component: ValuesPicker,
        trapFocus: true,
        canCancel: !!this.activeValues.a.length,
        // width: 480,
        props: {
          currentlyApplied: this.activeValues.a,
          callback: this.valuesChangeCallback,
        },
      });
    },
    pctFormat: function(value) {
      return `${(value * 100).toFixed(2)}%`;
    },
    decimalRatioToScoreFormat: function(value) {
      return (value * 10).toFixed(0);
    },
    dollarSliderFormat: function(value) {
      if (value === 500000000000) {
        return bigDollarFormat(value) + '+';
      }
      return bigDollarFormat(value);
    },
    labelForColumn: function(key, values) {
      const thisKey = key.replace('composite_values_', '');
      if (thisKey in this.activeValues.byId) {
        return `${this.activeValues.byId[thisKey].name} Alignment`;
      }
      return '';
    },
    columnShouldBeVisible: function(values) {
      const shouldBeVisible = values.id in this.activeValues.byId &&
                this.results.rows.length > 0 &&
                `composite_values_${values.id}` in this.results.rows.slice(-1)[0];
      console.log(values.name, values.id, 'should be visible:', shouldBeVisible);
      return shouldBeVisible;
    },
    valuesChangeCallback: function(newValues) {
      this.results.loading = true;
      this.$nextTick(async () => {
        // Process metrics details
        newValues.forEach((itm) => {
          itm.metrics.forEach((m) => {
            m.details = this.metrics.byId[m.metric_description];
          });
        });
        
        // Set active values FIRST
        this.$set(this.activeValues, 'a', newValues);
        
        // Auto-switch to Values Screens tab when values are selected
        if (newValues.length > 0) {
          this.showingFinancialData = false;
        } else {
          this.showingFinancialData = true;
        }
        
        // Clear and rebuild activeValues.byId BEFORE loading metrics
        Object.keys(this.activeValues.byId).forEach((i) => this.$delete(this.activeValues.byId, i));
        
        // Populate activeValues.byId immediately
        this.activeValues.a.forEach((itm) => {
          this.activeValues.byId[itm.id] = itm;
        });
        
        // Clear old composite columns and individual metric columns from previous selections
        for (const col in this.filters.columns) {
          if (col.indexOf('composite_') === 0 || this.individualMetricColumns.includes(col)) {
            this.$delete(this.filters.columns, col);
          }
        }
        
        // Set up filter columns
        this.filters.columns['composite'] = [0, 10];
        this.activeValues.a.forEach((itm) => {
          this.filters.columns[`composite_values_${itm.id}`] = [0, 10];
          itm.metrics.forEach(metric => {
            this.filters.columns[metric.metric_description] = [0, 1];
          });
        });

        // NOW load values metrics (this can be async)
        if (newValues.length > 0) {
          const valueIds = newValues.map(item => item.id);
          await this.loadValuesMetrics(valueIds);
        } else {
          this.valuesMetrics = {};
        }

        if (this.results.pinned.length > 0) {
          this.getPartialUpdate();
        }

        eventBus.$emit('FundScreener:values-changed');

        // Apply filtering
        if (this.isDataLoaded) {
          this.applyFiltersAndPagination();
        } else {
          this.maybeGetResults(true);
        }
        this.results.loading = false;
      });
    },
    getPartialUpdate: async function() {
      const params = new URLSearchParams({
        values: this.activeValues.a.map((itm) => {
          return itm.id;
        }).join(','),
        in_fund_ids: this.results.pinned.map((itm) => {
          return itm.ticker__id;
        }).join(','),
        per_page: 999, // In the case that someone pins lots of funds, avoid having to paginate or accidentally clipping the partial update
      });
      const fundsResponse = await fetch(`/api/v1/explore/funds/?${params}`);
      const fundsData = await fundsResponse.json();
      const dataByTickerId = fundsData.funds.reduce((acc, itm) => {
        acc[itm.ticker__id] = itm;
        return acc;
      }, {});
      this.results.pinned.forEach((itm) => {
        if (itm.ticker__id in dataByTickerId) {
          Object.assign(itm, dataByTickerId[itm.ticker__id]);
        }
      });
    },
    buildQueryParams: function(paginate=true) {
      let values;
      if (!this.activeValues.a || this.activeValues.a.length === 0) {
        values = "NOVALUES";
      } else {
        values = this.activeValues.a.map((itm) => itm.id).join(',');
      }
      const filters = {
        values: values,
        page: paginate ? this.results.page : 0,
      };
      if (this.filters.fundType.length > 1 || this.filters.fundType[0] !== 'All') {
        filters.fund_types = this.filters.fundType.join(',');
      }
      // TODO: We should just match these to exactly what the backend expects so we don't need to manually reassign
      // like this...
      filters.asset_type = this.filters.assetType;
      if (this.filters.symbolSearch) {
        filters.search_symbol = this.filters.symbolSearch;
      }
      if (this.filters.nameSearch) {
        filters.search_name = this.filters.nameSearch;
      }
      if (this.filters.engagementLevel) {
        filters.engagement_level = this.filters.engagementLevel;
      }
      if (this.filters.esgMandate) {
        filters.esg_mandate = true;
      }
      if (this.filters.shareClass) {
        [
          filters.share_class = this.filters.shareClass.join(';'),
        ];
      };
      if (this.sort.column) {
        // if (!this.sort.column.includes('financial_data')) {
        filters.sort = this.sort.column;
        filters.sort_dir = this.sort.dir;
        // }
      }

      for (const filterCol in this.filters.columns) {
        if (filterCol.startsWith('financial_data.')) {
          const filterValue = this.filters.columns[filterCol];
          let minValue;
          
          if (Array.isArray(filterValue)) {
            minValue = filterValue[0];
          } else {
            minValue = filterValue;
          }
          
          if (minValue !== null && minValue !== undefined && minValue !== 0) {
            filters[`${filterCol}_min`] = minValue;
          }
        } else if (this.filters.columns[filterCol][0] !== null && this.filters.columns[filterCol][0] !== undefined) {
          // Handle non-financial data filters as before
          if (!(!isNaN(filterCol) && this.filters.columns[filterCol][0] === 0 && this.filters.columns[filterCol][1] === 1)) {
            filters[`${filterCol}_min`] = this.filters.columns[filterCol][0];
            filters[`${filterCol}_max`] = this.filters.columns[filterCol][1];
          }
        }
      }
      filters['ticker__total_value_min'] = this.filters.columns['ticker__total_value'][0] * (this.headerConfig.minAssets === 'm' ? 1000000 : 1000000000);
      filters['ticker__total_value_max'] = this.filters.columns['ticker__total_value'][1] * (this.headerConfig.maxAssets === 'm' ? 1000000 : 1000000000);

      if (window.location.hash) {
        filters.in_model_portfolio = window.location.hash.replace('#', '');
      }

      if (this.universePortfolio) {
        filters.in_portfolio = this.universePortfolio.id;
      }
      return new URLSearchParams(filters);
    },
    addPinned(row) {
      if (this.results.pinned.some(pinned => row['ticker__id'] === pinned['ticker__id'])) {
        this.results.pinned = this.results.pinned.filter(pinned => row['ticker__id'] !== pinned['ticker__id']);
        return;
      }
      this.results.pinned.push(row);
    },
    isFundPinned(fund) {
      return this.results.pinned.some(pinned => fund.ticker__id === pinned.ticker__id);
    },
    _getResults: async function(resetPage) {
      // Should always be called through maybeGetResults() to ensure loading spinner and debounce are in place.
      const filters = this.getFilterString();

      this.results.loading = true;
      console.error('START OF LOADING HERE');
      const starttime = new Date();
      console.error('Current datetime:', starttime.toLocaleTimeString() + '.' + starttime.getMilliseconds());
      if (this.results.error) {
        this.results.error.close();
        this.results.error = null;
      }
      if (resetPage) {
        this.results.page = 1;
      }

      const params = this.buildQueryParams();
      const fundsResponse = await fetch(`/api/v1/explore/funds/?${params}`);
      if (fundsResponse.ok) {
        const fundsData = await fundsResponse.json();
        console.error('fundsData:', fundsData);
        const checkedRows = JSON.parse(JSON.stringify(this.results.pinned));
        this.results.pinned = [];
        this.results.pinned.push(...checkedRows);
        this.results.perPage = this.results.pinned.length + 25;
        this.results.rows = [];
        this.results.rows.push(...checkedRows);
        this.results.total = fundsData.total;
        // dedupe pinned
        this.results.rows.push(...fundsData.funds.filter(fundsDataRow => !this.results.pinned.some(pinnedRow => pinnedRow['ticker__id'] === fundsDataRow['ticker__id'])));
        this.prevFilters = filters;
        telemetry.track('Filter Applied', {params})

      } else {
        this.results.error = this.$buefy.snackbar.open({
          message: 'There was an unexpected error loading the results for this search, our team has been notified.',
          type: 'is-warning',
          position: 'is-bottom',
          actionText: 'Retry',
          cancelText: 'Close',
          indefinite: true,
          onAction: () => {
            this.maybeGetResults();
          },
        });
      }
      this.results.loading = false;
      console.error('END OF LOADING HERE');
      const endtime = new Date();
      console.error('Current datetime:', endtime);
      const duration = endtime - starttime;
      console.error('Duration of loading:', duration, 'ms');
    },
    maybeGetResults(resetPage) {
        if (!this.isDataLoaded) {
            // First time - load all data
            this.loadAllFundsData();
            return;
        }
        
        // Subsequent times - just re-filter
        if (resetPage) this.results.page = 1;
        this.applyFiltersAndPagination();
    },
    async maybeGetResultsWithValuesReload(resetPage) {
        if (!this.isDataLoaded) {
            // First time - load all data
            this.loadAllFundsData();
            return;
        }
        
        // Check if values-relevant filters have changed (category, type, universe)
        const currentValuesFilters = {
            fundType: [...this.filters.fundType],
            assetType: [...this.filters.assetType],
            universePortfolioId: this.universePortfolio?.id || null,
        };
        
        const valuesFiltersChanged = (
            JSON.stringify(currentValuesFilters.fundType) !== JSON.stringify(this.lastValuesFilters.fundType) ||
            JSON.stringify(currentValuesFilters.assetType) !== JSON.stringify(this.lastValuesFilters.assetType) ||
            currentValuesFilters.universePortfolioId !== this.lastValuesFilters.universePortfolioId
        );
        
        // If we have active values and relevant filters changed, reload them
        if (this.activeValues.a.length > 0 && valuesFiltersChanged) {
            await this.loadValuesMetrics(this.activeValues.a.map(v => v.id));
            // Update the tracked filters
            this.lastValuesFilters = currentValuesFilters;
        }
        
        // Then apply filtering with fresh values data
        if (resetPage) this.results.page = 1;
        this.applyFiltersAndPagination();
    },
    debouncedGetResults(resetPage, delay = 300) {
        // Clear existing timer
        if (this.debounceTimer) {
            clearTimeout(this.debounceTimer);
        }
        
        // Set loading state immediately for instant feedback
        this.results.loading = true;
        
        // Debounce the actual filtering
        this.debounceTimer = setTimeout(() => {
            this.maybeGetResults(resetPage);
        }, delay);
    },
    changePage(page) {
        this.results.page = page;
        this.applyFiltersAndPagination(); // No API call!
    },
    getFilterString() {
      const data = [
        this.removeEmpty(this.filters),
        this.removeEmpty(this.sort),
      ];
      return JSON.stringify(data);
    },
    removeEmpty(data) {
      const result = {};

      for (const key in data) {
        if (Object.prototype.hasOwnProperty.call(data, key)) {
          const value = data[key];
          if (!value) continue;

          if (typeof value === 'object') {
            if (Array.isArray(value)) {
              if (value.length === 0) continue;
            } else {
              if (Object.keys(value).length === 0) continue;
            }
          }
          result[key] = value;
        }
      }
      return result;
    },
    onResultsPageChange: async function(page) {
      this.results.prevPage = this.results.page;
      this.results.page = page;
      this.maybeGetResults();
    },
    onResultsSort: async function(field, dir) {
      // HACK: This replacement is to bridge the way that the buefy template
      // expects column references to the way django references related
      // objects. It may cause bugs.
      // if (field.includes('financial_data.')) {
      //   this.sort.column = field;
      //   this.sort.dir = dir;
      //   this.results.rows.sort((a, b) => this.sort.dir === 'asc' ? a.financial_data.financial_data[this.currentReturnTimeFrame] - b.financial_data.financial_data[this.currentReturnTimeFrame] :
      //       b.financial_data.financial_data[this.currentReturnTimeFrame] - a.financial_data.financial_data[this.currentReturnTimeFrame]);
      //   return;
      // }
      // if (!field.includes('financial_data.')) {
      this.sort.column = !field.includes('financial_data.') ? field.replace('.', '__') : field;
      // }
      this.sort.dir = dir;
      this.maybeGetResults(true);
    },
    async requestDownload() {
      this.downloadPending = true;
      this.downloadStart = window.performance.now();
      try {
        const url = '/api/v1/explore/funds/download?' + this.buildQueryParams(false);
        const res = await (await fetch(url)).json();
        this.downloadTaskID = res.task;
        this.downloadStatusInterval = window.setInterval(() => this.getDownloadStatus(), 1500);
      } catch (e) {
        this.handleDownloadError(e.toString());
        throw e;
      }
    },
    async getDownloadStatus() {
      try {
        const url = `/api/v1/explore/funds/download/${this.downloadTaskID}/status`;
        const res = await (await fetch(url)).json();
        this.updateDownloadStatus(res);
      } catch (e) {
        this.handleDownloadError(e.toString());
        throw e;
      }
    },
    updateDownloadStatus(task) {
      if (task.status === 'pending') return this.handleSlowDownload(task);

      this.downloadPending = false;
      if (task.status === 'complete') this.handleDownloadSuccess();
      if (task.status === 'failed') this.handleDownloadError(task.meta.error);
    },
    handleSlowDownload(task) {
      const now = window.performance.now();
      if (now - this.downloadStart < 5000) return;

      // if (!task.meta.started) return this.handleDownloadError('Background task has not started. Is celery running?');
      this.showDownloadMessage();
    },
    showDownloadMessage() {
      if (this.downloadMessageShown) return;

      this.$buefy.snackbar.open({
        message: 'Looks like your download may take a while. Your file will be emailed to you when ready; you can safely close this page or window.',
        position: 'is-top',
        indefinite: true,
      });
      this.downloadMessageShown = true;
    },
    handleDownloadSuccess() {
      this.downloadReady = true;
      this.resetDownload();
    },
    handleDownloadError(error) {
      this.resetDownload();
      console.log(error);

      this.$buefy.snackbar.open({
        message: 'There was an error while preparing your download. Please try again or contact support.',
        type: 'is-danger',
        position: 'is-top',
        duration: 5000,
      });
    },
    resetDownload() {
      this.downloadPending = false;
      this.downloadMessageShown = false;
      window.clearInterval(this.downloadStatusInterval);
    },
    sendHoldingsToPortfolio: function(row) {
      eventBus.$emit('FundScreener:add-funds-to-portfolio', row);
      this.showingPortfolioSideBar = true;
    },
    selectPortfolio: function(option) {
      if (option) {
        this.universePortfolio = option;
        // Show immediate feedback for universe change
        this.$buefy.toast.open({
          message: `Filtering to ${option.name} universe...`,
          type: 'is-info',
          duration: 2000,
          position: 'is-bottom'
        });
      } else {
        this.universePortfolio = null;
        this.$buefy.toast.open({
          message: `Showing all funds`,
          type: 'is-info',
          duration: 1500,
          position: 'is-bottom'
        });
      }
      this.maybeGetResults(true);
    },
    applyPathRouting: function() {
      if (window.location.pathname) {
        const pathname = window.location.pathname.split('/');
        const subsection = pathname[pathname.length - 2];
        if (subsection !== 'fund-screener') {
          this.detailFund = this.resultsBySymbol[subsection];
        } else {
          this.detailFund = null;
        }
      }
    },
    exchangeHolding: function(fund) {
      if (this.exchanging) {
        eventBus.$emit('FundScreener:add-funds-to-portfolio', [fund], 'exchange');
      }
    },
    closeExchangeMode: function() {
      eventBus.$emit('FundScreener:exchange-holding', null);
    },
    returnNumberToShow(number) {
      if (!number) {
        return 'N/A';
      }
      return number.toFixed(2);


      // const importantKeys = this.timeFrames.map(timeFrame => {
      //   return `Load Adjusted Return ${timeFrame} Month-End`;
      // });
      // if (!props.row.financial_data) return '';
      // const financialDataVals = Object.entries(props?.row?.financial_data.financial_data).filter(([key, val]) => {
      //   return importantKeys.includes(key);
      // });
      // const areAllZero = financialDataVals?.every(([key, val]) => !isNaN(val) && parseFloat(val) === 0);
      // if (areAllZero || props.row.financial_data.financial_data[this.currentReturnTimeFrame] * 1 === 0.00) {
      //   return '';
      // }

      // return !isNaN(props.row.financial_data.financial_data[this.currentReturnTimeFrame]) ? `${(props.row.financial_data.financial_data[this.currentReturnTimeFrame] * 1).toFixed(2)}%` : '';
    },
    async openDetailPage() {
      const params = new URLSearchParams(window.location.search);
      const symbol = params.get('ticker');
      const values = params.get('values');

      if (!symbol) return;
      this.skipValuesPicker = true;

      const ids = this.parseIDs(values);
      const valueSets = await this.getValueSets(ids);

      this.$router.push({
        name: 'detail',
        params: { symbol, values: valueSets },
      });
    },
    parseIDs(input) {
      if (!input) return [];
      const ids = input.split(',').map(id => parseInt(id));
      return ids.filter(id => !isNaN(id));
    },
    async getValueSets(ids) {
      if (!ids || ids === []) return [];
      const res = await fetch('/api/v1/screen_sets/');
      const data = await res.json();

      const valueSets = data.screen_sets;
      return valueSets.filter(set => ids.includes(set.id));
    },
  },
  computed: {
    sortedReturns() {
      const returnsToSort = [...this.headerConfig.returns];
      return returnsToSort.sort((a, b) => {
        const aNumber = a === 'YTD' ? 0 : a.slice(0, -1);
        const bNumber = b === 'YTD' ? 0 : b.slice(0, -1);
        return aNumber - bNumber;
      });
    },
    engagementLevelString() {
      const engLevelDict = {
        0: 'Minimal',
        1: 'Base',
        2: 'Deep',
      };
      return engLevelDict[this.filters.engagementLevel];
    },
    activeValueSets() {
      return this.activeValues.a;
    },
    actionsColumnVisible() {
      return this.showingPortfolioSideBar || this.exchanging;
    },
    filteredShareClasses() {
      console.log('SHARE CLASSES', this.filters.shareClasses);
      if (!this.shareClassInput) {
        return this.filters.shareClasses;
      }
      return this.filters.shareClasses.filter(type => type?.toLowerCase().indexOf(this.shareClassInput.toLowerCase()) >= 0);
    },
    filteredFundTypes() {
      if (!this.searchFundTypesInput) {
        return this.fundTypes;
      }
      return this.fundTypes.filter(type => type.toLowerCase().indexOf(this.searchFundTypesInput.toLowerCase()) >= 0);
    },
    csvData: function() {
      if (this.results.rows.length === 0 || !this.$refs || !this.$refs.resultsTable) {
        return;
      }
      const cols = this.$refs.resultsTable.newColumns.filter((itm) => {
        return itm.label;
      }).map((itm) => {
        return {
          'label': itm.label,
          'field': itm.field,
        };
      });
      const rows = this.results.rows.map((row) => {
        return cols.reduce((acc, col) => {
          acc[col.label] = _.get(row, col.field);
          return acc;
        }, {});
      });
      let csvFile = papa.unparse(rows);
      csvFile = `"
        Copyright Stake PBC. All rights reserved. You may not use the information contained herein as the basis for any derivative product 
        (including, without limitation, constructing, modifying, or maintaining any index or passively managed investment products) 
        without the express written consent of Stake PBC.
        The information, data, analyses and opinions contained herein
        (1) include the proprietary information of Stake PBC, or third party content providers
        (2) may not be copied or redistributed, (3) do not constitute investment advice offered by Stake PBC
        (4) are provided solely for informational purposes
        (5) are not warranted to be timely, complete or accurate. Except to the extent otherwise specifically
            required by law, neither Stake PBC, nor its affiliates nor their third party content providers shall
            be responsible for any trading decisions, damages or other losses resulting from, or related to, this
            information, data, analyses, opinions or their use.
      "\n\n${csvFile}`;
      return `data:text/csv;charset=utf-8,${encodeURIComponent(csvFile)}`;
    },
    timeFrames() {
      return ['YTD', '1Y', '2Y', '3Y', '5Y', '10Y', '15Y'];
    },
    returnColumnName() {
      return `${this.currentReturnTimeFrame.split(' ').slice(3).join(' ')} Return`;
    },
    applicableMetrics: function() {
      return this.activeValues.a.reduce((acc, val) => {
        acc.push(...val.metrics.filter((itm) => {
          return itm.details;
        }));
        return acc;
      }, []);
    },
    resultsBySymbol: function() {
      return this.results.rows.reduce((acc, itm) => {
        acc[itm.ticker__symbol] = itm;
        return acc;
      });
    },
  },
  updated() {
    const checkboxes = Array.from(this.$el.querySelectorAll('.checkbox-cell'));
    const headerCheckbox = checkboxes[0];
    const checkboxesEnd = checkboxes.slice(1);
    const headerstThWrap = this.$el.querySelectorAll('.th-wrap');
    checkboxesEnd.forEach(checkbox => checkbox.classList.add('flex', 'centerCenter', 'height100Px'));
    headerCheckbox?.classList && headerCheckbox.classList.add('flex', 'centerCenter', 'height55Px');
    headerstThWrap.forEach(header => header.classList.add('verticalAlignMiddle'));
  },
  mounted() {
    // this.$refs.searchInput.$el.querySelector('input').style.backgroundColor = "gray";
    this.openDetailPage(); // If there is a ticker value in url params
  },
  created: async function() {
    this.viewIsLoading = true;
    const self = this;
    this.$root.advisor = new Advisor();

    this.$root.$data.csrfToken = document.querySelector('[name="csrfmiddlewaretoken"]').value;

    this.loadImpactFactors();
    this.loadFundTypes();
    this.loadPortfolios();

    eventBus.$on('ValueTag:metric-selected', function(metric) {
      // This activates additional columns in the results table when you
      // select metrics from any values tag.
      if (metric.id in self.selectedMetrics) {
        self.$delete(self.selectedMetrics, metric.id);
      } else {
        self.$set(self.selectedMetrics, metric.id, metric);
        self.filters.columns[metric.id] = [0, 1];
      }
    });

    eventBus.$on('FundScreener:working-portfolio-selected', function(option) {
      self.workingPortfolios[0].name = option.name;
    });

    eventBus.$on('FundScreener:exchange-holding', async function(holding) {
      if (!holding) {
        // Clear exchange mode immediately
        self.exchanging = null;
      } else {
        self.exchanging = holding;
      }
      if (holding && holding.ticker__benchmark_description) {
        // Set fund type filter to show similar funds if available
        self.filters.fundType = [holding.ticker__benchmark_description];
        
        // When no values are selected, add additional category-based filtering to improve relevance
        if (self.activeValues.a.length === 0) {
          // Also filter by asset type (ETF vs Mutual Fund) for better matching
          if (holding.ticker__asset_type) {
            const assetTypeMapping = {
              'ETF': '2',
              'Mutual Fund': '3'
            };
            const assetTypeCode = assetTypeMapping[holding.ticker__asset_type];
            if (assetTypeCode) {
              self.filters.assetType = [assetTypeCode];
            }
          }
        }
        
        // Reload values metrics with new filters if values are active BEFORE showing results
        if (self.activeValues.a.length > 0) {
          await self.loadValuesMetrics(self.activeValues.a.map(v => v.id));
        }
        
        // Trigger search to show available funds (works with or without values)
        self.maybeGetResults(true);  // Reset to page 1
      } else {
        // Clear exchange-related filters when exchange is cancelled or holding is invalid
        self.filters.fundType = [];
        self.filters.assetType = [];
        
        // Reload values metrics with cleared filters if values are active BEFORE showing results
        if (self.activeValues.a.length > 0) {
          await self.loadValuesMetrics(self.activeValues.a.map(v => v.id));
        }
        
        self.maybeGetResults(true);
      }
    });

    if (window.location.search && window.location.search.indexOf('values_from') > -1) {
      this.tooltipActive = false;
      const qs = new URLSearchParams(window.location.search);
      if (qs.get('values_from').indexOf('modelportfolio_') === 0 || qs.get('values_from').indexOf('shareowner_') === 0) {
        this.valuesChangeCallback(this.portfolios.filter((itm) => {
          return itm.id === qs.get('values_from');
        })[0].screen_sets);
      } else {
        const prospectsResponse = await fetch(`/api/v1/prospects/${qs.get('values_from')}/`);
        const prospectData = await prospectsResponse.json();
        this.valuesChangeCallback(prospectData.prospect.screen_sets);
      }
    } else {
      window.setTimeout(() => {
        this.tooltipAlways = true;
      }, 1000);
    }
    // V2
    if (this.$root?.advisor?.firm?.preferences?.approved_starting_universe) {
      this.universePortfolio = this.$root?.advisor?.firm?.preferences?.approved_starting_universe;
    }
    // if (!this.skipValuesPicker) this.openValuesPicker();
    this.filters.shareClasses = SHARE_CLASSES;
    // this.maybeGetResults('immediate');
    await this.loadAllFundsData();
    this.viewIsLoading = false;
  },
};
</script>

<style lang="scss">

.fund-screener {
  .th-wrap > span {
    width: 100%;
  }

  .tabs.is-toggle li.is-active a {
    background-color: var(--black-95);
    border-color: var(--black-95);
  }
  h1 {
    color: red;
  }
  .filters {
    grid-area: filters;
  }
  .metadata {
    grid-area: metadata;
  }
  .results {
    grid-area: results;
  }
  .portfolio {
    grid-area: portfolio;
  }
  .fund-detail-page {
    font-family: "Inter", "Inter Variable", "Roboto", "Segoe UI", "Segoe UI Variable", "SF Pro", "Helvetica", "Arial", sans-serif;
    color: rgb(49, 47, 48);
  }
  .metricard {
    width: 10rem;
    height: 7rem;
    padding: 0.5rem;
    margin: 0.5rem;
  }

  .table td.has-bg-color {
    padding: 0;

    & > div {
      padding: 0.5em 0.75em;
    }
  }

  .filters {
    .disabled {
      pointer-events: none;
      opacity: 0.5;
    }
  }

  .exchange-comparison {
    text-align: left;
    width: 600px;
    padding: 1rem;
    line-height: 1.4rem;

    .fund-name {
      min-height: 4.2rem;
    }

  }
}
.fund-screener-v2 tr,
.fund-screener-v2 td,
.fund-screener-v2 td > div {
  height: 100%;
}
.dropdown-content {
  padding: 0;
}
.input {
  background-color: #f6f7f8;
  border: none;
}
.table-wrapper {
  min-height: 60vh;
}
.b-slider {
  margin: 0;
  margin-top: 10px;
}
</style>
